<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Stock/ Stock Management
           
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 6 || roleid == 7">
        <b-tab-item label="ເຄື່ອງເຂົ້າສາງ">
          <div class="columns scrollme">
            <div class="column" >
              <b-field>
                <div class="columns" style=" display: flex">
                  <!-- <div class="column column-40" style="padding-right: 80px;">
                    <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ຟອມເອົາເຄື່ອງເຂົ້າສາງ</div>    
                    <div class="columns">
                      <div class="column">   
                        ຜູ້ສະໜອງ
                        <b-field label="">
                          <Multiselect
                            placeholder="ເລືອຜູ້ສະໜອງ"
                            v-model.trim="selectedVender"
                            label="NAME"
                            track-by="ID"
                            :options="stockVenderList"
                            @input="onSelectVender"
                          >
                          </Multiselect>
                        </b-field>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">  
                        ວັນທີ
                        <b-field label="">
                          <b-field>
                            <b-datepicker
                              :date-formatter="dateFormatter"
                              v-model="stockDate"
                            >  
                            </b-datepicker>
                          </b-field>
                        </b-field>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        ສິນຄ້າ
                        <b-field label="">
                          <Multiselect
                            placeholder="ເລືອກສິນຄ້າ"
                            v-model.trim="selectedStockProduct"
                            label="NAME"
                            track-by="ID"
                            :options="stockProductSub"
                          >
                          </Multiselect>
                        </b-field>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column">
                        ຈຳນວນສິນຄ້າ (ຊື້)
                        <b-input
                          v-model.trim="selectedStockProductAmount" 
                          type="number"
                          min="1"
                          pattern="[0-9]+"
                        >
                        </b-input>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column">
                        ຈຳນວນເງິນລວມ
                        <b-input
                          v-model.trim="selectedStockProductTotal" 
                          type="number"
                          min="1"
                          pattern="[0-9]+"
                        >
                        </b-input>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column">
                        <b-button
                          class="btn-group-margin"
                          type="is-success"  
                          @click="saveStockIn()"
                          >ບັນທຶກ
                        </b-button> 
                      </div>
                    </div>

                  </div> -->
                  <!-- <div class="column column-60"> -->   
                  <div class="column">
                  
                    <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ປະຫວັດ ເຄື່ອງເຂົ້າສາງ</div>    
                    <div class="columns">
                      <div class="column" style="padding-right:50px;">
                        <b-field grouped>
                          <b-field>
                            <b-datepicker
                              :date-formatter="dateFormatter"
                              v-model="stockStartDate"
                            >
                            </b-datepicker>
                          </b-field>
                        </b-field>
                      </div>
                      <div class="column" style="padding-right:50px;">
                        <b-field grouped>
                          <b-field>
                            <b-datepicker
                              :date-formatter="dateFormatter"
                              v-model="stockEndDate"
                            >
                            </b-datepicker>
                          </b-field>
                        </b-field>
                      </div>

                      <div class="column" style="padding-right:50px;">
                        <b-field>
                          <Multiselect
                            placeholder="ເລືອກສິນຄ້າ"
                            v-model.trim="selectedProduct"
                            label="NAME"
                            track-by="ID"
                            :options="stockProductList"
                          >
                          </Multiselect>
                        </b-field>
                      </div> 

                      <div class="column" style="padding-right:50px;">
                        <b-field>
                          <Multiselect
                            placeholder="ຜູ້ຊື້"
                            v-model.trim="selectedPurchaser"
                            label="NAME"
                            track-by="ID"
                            :options="purchaserList"
                          >
                          </Multiselect>
                        </b-field>
                      </div> 

                      <div class="column">
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-info"
                            @click="getStockHistory(1)"
                            >ເບິ່ງຂໍ້ມູນ
                          </b-button>
                        </b-field>
                      </div>
                    
                    </div>
                    <table class="table is-fullwidth is-narrow is-small">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="3%">#</th>

                          <th class="has-text-left " width="5%">
                            ວັນທີ
                          </th>
                          <th class="has-text-left " width="20%">
                            ສິນຄ້າ
                          </th>
                      
                          <th class="has-text-right " width="10%">
                            ຈຳນວນ
                          </th>  
                          <th class="has-text-right " width="10%">
                            ຍັງເຫຼືອ
                          </th>
                          <th class="has-text-right " width="10%">
                            ລວມເງິນຊື້
                          </th>
                          <th class="has-text-right " width="10%">
                            ລາຄາ<br>ສະເລ່ຍ
                          </th>
                          <th class="has-text-right " width="10%">
                            ລາຄາຂາຍ<br>ລ່າສຸດ
                          </th>
                          <th class="has-text-right " width="10%">
                            ກຳໄລ<br>ຄາດການ
                          </th>
                          
                          <th class="has-text-right " width="10%">  
                            ເສຍຫາຍ<br>ສູງສຸດ
                          </th>
                          
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in stockinHistory"
                          :key="data.ID"   
                        >
                          <td class="has-text-centered">{{ index + 1}}<br>{{ data.ID }}
                            <!-- <b-button v-if="data.STOCKIN === data.LOTREMAIN && data.WAIT_INSTOCK == 0 && data.MARKETBATCHID != null && data.COUNTPAYMENT == 0"  
                                class="is-small btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="cancelProductStockIn(data.ID, data.MARKETBATCHID, data.PURCHASERID)"           
                            >X
                            </b-button>  -->   
                          </td>

                          <td>
                            {{data.TXDATE}}
                          </td>
                          <td>
                            {{ data.PRODUCTNAME}}<br> <span style="color: chocolate">{{  data.VENDER }}</span>
                          </td>
            
                          
                          <td class="has-text-right">
                              {{ data.STOCKIN | formatNumberLocal }}
                          </td>
              
                          <td class="has-text-right">
                            <span style="font-weight: bold;">{{ data.LOTREMAIN | formatNumberLocal }}</span> <br>{{ data.UNIT }}
                          </td>
                          <td class="has-text-right">
                            {{ data.TOTALPRICE | formatNumberLocal }}   
                          </td>  
                          <td class="has-text-right">
                            {{ data.AVERAGEPRICE | formatNumberLocal }}
                          </td>  
                          <td class="has-text-right">
                            {{ data.SELLPRICE | formatNumberLocal }}
                          </td>  
                          <td class="has-text-right">
                            {{ data.E_PROFITPERUNIT | formatNumberLocal }}<br>
                            {{ data.E_ALLPROFIT | formatNumberLocal }}
                            
                          </td> 
                          <td class="has-text-right">
                            {{ data.MAXLOSEQUANTITY | formatNumberLocal }}
                          </td>  
                                                        
                        </tr>
                      </tbody>
                      <tfoot>
                            <tr>
                              <th colspan="5" class="has-text-right">
                                ລວມ
                                {{ stockinHistory.length | formatNumberLocal }}
                                ລາຍການ
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(stockinHistory, (i) => i["TOTALPRICE"] * 1)  
                                    | formatNumberLocal  
                                }}
                              </th>
                              <th>

                              </th>
                              <th>
                                
                              </th>
                              <th>
                                
                              </th>
                              <th>
                                
                              </th>
                              
                            </tr>
                          </tfoot>
                      
                    </table>
                  </div>
                </div>
              </b-field>
            </div>
          </div>
          
        </b-tab-item>

        <b-tab-item label="ເຄື່ອງໃນສາງ">
          
          <b-tabs v-model="activeTabSub" >
            <!-- <b-tab-item label="ເຄື່ອງໃນສາງ (ສັງລວມ)">
              <div class="columns scrollme">
                <div class="column" >
                  <b-field>
                    <table class="table is-fullwidth is-narrow is-small">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="3%">#</th>

                          <th class="has-text-left " width="15%">
                             ສິນຄ້າ
                          </th>
    
                          <th class="has-text-right " width="10%">
                            ມູນຄ່າ<br>ຊື້ເຂົ້າ
                          </th>
                      
                          <th class="has-text-right " width="10%">
                            ມູນຄ່າ<br>ຂາຍອອກ
                          </th>  
                          <th class="has-text-right " width="10%">
                            ມູນຄ່າ<br>ຍັງເຫຼືອ
                          </th>
                          <th class="has-text-right " width="5%">
                            ສິນຄ້າ<br>ຂາເຂົ້າ
                          </th>
                          <th class="has-text-right " width="5%">
                            ສິນຄ້າ<br>ຂາອອກ
                          </th>
                          <th class="has-text-right " width="5%">
                            ສິນຄ້າ<br>ຍັງເຫຼືອ
                          </th>
                          <th class="has-text-right " width="5%">
                            ສິນຄ້າ<br>(ປຈວ)
                          </th>
                          <th class="has-text-right " width="5%">
                            Check<br>(ສິນຄ້າ)
                          </th>
                          <th class="has-text-right " width="10%">
                            ມູນຄ່າຍັງເຫຼືອ<br>(ປຈວ)
                          </th>
                          <th class="has-text-right " width="10%">
                            Check<br>(ມູນຄ່າ)
                          </th>
                          
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in productSummary"
                          :key="data.PRODUCTID"
                        >
                          <td class="has-text-centered">{{ index + 1 }}</td>

                          <td>
                            {{data.PRODUCTNAME}}
                          </td>
                          <td class="has-text-right">
                            {{data.STOCKINVALUE | formatNumberLocal}}
                          </td> 
                          <td class="has-text-right">
                            {{data.STOCKOUTVALUE | formatNumberLocal}}
                          </td> 
                          <td class="has-text-right">
                            <span v-if="data.STOCKVALUEDIFF < 0" style="background-color: yellow; padding: 0 10px 0 10px;">
                              {{data.STOCKVALUEDIFF | formatNumberLocal}}
                            </span>
                            <span v-else>
                              {{data.STOCKVALUEDIFF | formatNumberLocal}}
                            </span>
                           
                          </td>
            
                          
                          <td class="has-text-right">
                            {{data.STOCKIN | formatNumberLocal}}
                          </td>
              
                          <td class="has-text-right">
                            {{data.STOCKOUT | formatNumberLocal}}
                          </td>
                          <td class="has-text-right">
                            {{data.STOCKQUANTITY | formatNumberLocal}}
                          </td>  
                          
                          <td class="has-text-right" style="color: red; font-weight: bold;">
                            {{ data.USAGEQUANTITY | formatNumberLocal }}
                          </td> 
                          <td class="has-text-right">
                           
                            <span v-if="data.QUANTITYCHECK >= 0" style="background-color: greenyellow; padding: 0 10px 0 10px; font-weight: bold"> 
                              {{ data.QUANTITYCHECK | formatNumberLocal }}
                            </span>
                            <span v-else  style="background-color: red; color: white; padding: 0 10px 0 10px; font-weight: bold">
                              {{ data.QUANTITYCHECK | formatNumberLocal }}
                            </span>
                          </td> 
                          <td class="has-text-right" style="color: red; font-weight: bold;">
                            {{ data.USAGEVALUE | formatNumberLocal }}
                          </td> 
                          <td class="has-text-right">
                            <span v-if="data.VALUECHECK >= 0" style="background-color: greenyellow; padding: 0 10px 0 10px; font-weight: bold"> 
                              {{ data.VALUECHECK | formatNumberLocal }}
                            </span>
                            <span v-else  style="background-color: red; color: white; padding: 0 10px 0 10px; font-weight: bold">
                              {{ data.VALUECHECK | formatNumberLocal }}
                            </span>
                            
                          </td> 
                          

                          
                                                        
                        </tr>
                      </tbody>
                      <tfoot>
                    <tr>
                      <th colspan="2" class="has-text-centered">
                        ລວມ
                        {{ productSummary.length | formatNumberLocal }}
                        ລາຍການ
                      </th>
                      <th class="has-text-right">
                        {{
                          _.sumBy(productSummary, (i) => i["STOCKINVALUE"] * 1)
                            | formatNumberLocal
                        }}
                      </th>
                      <th class="has-text-right">
                        {{
                          _.sumBy(productSummary, (i) => i["STOCKOUTVALUE"] * 1)
                            | formatNumberLocal
                        }}
                      </th>
                      <th class="has-text-right">
                        {{
                          _.sumBy(productSummary, (i) => i["STOCKVALUEDIFF"] * 1)
                            | formatNumberLocal
                        }}
                      </th>
                      <th class="has-text-right">
                        
                      </th>
                      <th class="has-text-right">
                       
                      </th>
                      <th class="has-text-right">
                        
                      </th>
                      <th class="has-text-right">
                        
                      </th>
                      <th class="has-text-right">
                       
                      </th>
                      <th class="has-text-right">
                        {{
                          _.sumBy(productSummary, (i) => i["USAGEVALUE"] * 1)
                            | formatNumberLocal
                        }}
                      </th>
                      <th class="has-text-right">
                        {{
                          _.sumBy(productSummary, (i) => i["VALUECHECK"] * 1)
                            | formatNumberLocal
                        }}
                      </th>
                    </tr>
                  </tfoot>
                      
                    </table>
                  </b-field>
                </div>
              </div>
            </b-tab-item> -->
            <!-- <b-tab-item label="ເຄື່ອງໃນສາງ (ສຳລັບມອບອໍເດີ້)">
              <b-field style="font-weight: bold;">
                ລາຍການສິນຄ້າ ສຳລັບມອບອໍເດີ້ 
              </b-field>
    
              <div class="columns scrollme" v-if="dateFormatter(stockProductRemainDate) == dateFormatter(currentDate)">
                <div class="column" >
                  <b-field>
                    <table class="table is-fullwidth is-narrow is-small">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="3%">#</th>

                          <th class="has-text-left " width="15%">
                             ສິນຄ້າ
                          </th>
                          
                          <th class="has-text-right " width="5%">
                            ຈຳນວນ
                          </th>
                          <th class="has-text-right " width="5%">
                            ຫົວໜ່ວຍ
                          </th>
                          
                        </tr>  
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in stockProductRemainSavedList"
                          :key="data.PRODUCTID"
                        >
                          <td class="has-text-centered">{{ index + 1 }}</td>

                          <td>
                            {{data.PRODUCTNAME}}
                          </td>
                          
                          
                          <td class="has-text-right" style="color: red; font-weight: bold;">
                            {{ data.QUANTITY | formatNumberLocal }}
                          </td> 
                          <td class="has-text-right" >
                            {{ data.UNIT }}
                          </td> 

                        </tr>
                      </tbody>
                      
                    </table>
                  </b-field>
                </div>
                <div class="column" ></div>
              </div>
            </b-tab-item> -->
            
            <b-tab-item label="ເຄື່ອງໃນສາງ (ສຳລັບເອົາອອກສາງ)">
              <div class="columns scrollme" >
                <div class="column" >
                  <b-field>
                    <div class="columns" style=" display: flex">
                      
                      <div class="column">
                        

                        <div class="columns">
                          <div class="column">
                            <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ເຄື່ອງທີ່ມີໃນສາງ ( ແຍກຕາມ Lot )</div>    
                          </div>
                        
                          <div class="column" style="padding-right:50px;"> 
                            <b-field>
                              <Multiselect
                                placeholder="ເລືອກສິນຄ້າ"  
                                v-model.trim="selectedRemainProduct"
                                label="NAME"
                                track-by="ID"
                                :options="stockRemainProductList"
                              >
                              </Multiselect>
                            </b-field>
                          </div>

                          <div class="column" style="padding-right:50px;"> 
                            <b-field grouped>
                              <b-field>
                                <Multiselect
                                  placeholder="ສະຖານະ"  
                                  v-model.trim="selectedRemainProductStatus"
                                  label="NAME"
                                  track-by="ID"
                                  :options="stockStatusList"
                                >
                                </Multiselect>
                              </b-field>
                              
                              <b-field>
                                <b-button
                                  class="btn-group-margin"
                                  type="is-info"
                                  @click="onSelectedStockRemainProduct(0)"
                                  ><span style=" font-family: Phetsarath OT !important ;">ເບິ່ງຂໍ້ມູນ</span>
                                </b-button>
                              </b-field>
                            </b-field>
                              
                          </div>

                          <div class="column" style="padding-right:50px;"> 
                            <b-field grouped>
                              <b-field>  
                                <b-button
                                  class="btn-group-margin"
                                  type="is-success"
                                  @click="onSelectedStockRemainProduct(1)"
                                  >ເບິ່ງລາຍການ ລໍຖ້າອະນຸມັດ
                                </b-button>
                              </b-field>
                            </b-field>
                              
                          </div>
                          

                          
                        </div>
                        
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="3%">Lot</th>

                              <th class="has-text-left " width="08%">
                                ວັນທີຊື້ເຂົ້າສາງ
                              </th>
        
                              <th class="has-text-left " width="30%">
                                ສິນຄ້າ
                              </th>
                          
                              <th class="has-text-right " width="8%">
                                ຈຳນວນ<br>ຊື້ເຂົ້າ
                              </th>  
                              <th class="has-text-right " width="8%">
                                ຂາຍອອກ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ <br> ຫ້ອງການ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ <br> ຖິ້ມ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ<br>ລວມ
                              </th>
                              <th class="has-text-right " width="8%">
                                ຍັງເຫຼືອ
                              </th>
                              <th class="has-text-centered " width="10%">
                                ຈັດການ
                              </th>
                              
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr 
                              v-for="(data) in productInStock"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ data.ID }}<br> 
                              <span style="background-color: red; color: white;">{{ data.WAITID }}</span>
                            
                              </td>

                              <td>
                                {{data.TXDATE}}
                              </td>
                              <td class="has-text-left">
                                {{  data.PRODUCTNAME }}
                                <span style="color: coral;"> <br>{{ data.UNIT }}</span>     
                              </td> 
                              <td class="has-text-right">
                                {{ data.STOCKIN | formatNumberLocal }}
                              </td>
                
                              
                              <td class="has-text-right">
                                  {{ data.SELL | formatNumberLocal }}
                              </td>
                  
                              <td class="has-text-right">
                                {{ data.OFFICESELL | formatNumberLocal }}
                              </td>
                              <td class="has-text-right">
                                {{ data.BROKEN | formatNumberLocal }}
                              </td>  
                              <td class="has-text-right">
                                {{ data.ALLBROKEN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right">
                                {{ data.LOTREMAIN | formatNumberLocal }}
                              </td> 

                              <td class="has-text-right">
                                <b-button
                                  class="btn-group-margin"
                                  type="is-info"
                                  size="is-small"
                                  @click="getProductInStockDetail(data)"
                                  >ເອົາເຄື່ອງອອກ
                                </b-button>
                              </td> 
                                                            
                            </tr>
                          </tbody>
                          
                        </table>
                      </div>
                    </div>
                  </b-field>
                </div>
              </div>
            </b-tab-item>
            <b-tab-item label="ຕິດຕາມເຄື່ອງອອກສາງ" >
              <div class="columns scrollme" >
                <div class="column" v-if="isActiveStockOutForm">
                  <b-field>       
                    <div class="columns">    
                      <div class="column column-20" style="padding-right: 100px;">    
                        <div style="font-size:18px; font-weight: bold; margin-bottom: 10px">ຟອມເສຍຫາຍ</div>    
            
                        
                        <div class="columns">
                          <div class="column">  
                            ວັນທີ
                            <b-field label="">
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="stockOutDate"
                                >  
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div>
                        </div>
                        

                        <!-- <div class="columns">
                          <div class="column">
                            ຂາຍອອກ 
                            <b-input
                              v-model.trim="selectedStockProductSell" 
                              type="number"
                              min="1"
                              pattern="[0-9]+"
                              disabled="disabled"  
                            >
                            </b-input>
                          </div>
                        </div> -->

                        <div class="columns" style="margin-top: -25px;">   
                          <div class="column">
                            ເສຍຫາຍບາງສ່ວນ-ຂາຍໃຫ້ຫ້ອງການ
                            <b-input
                              v-model.trim="selectedStockProductOfficeSell" 
                              type="number"
                              min="1"
                              pattern="[0-9]+"
                            >
                            </b-input>
                          </div>
                        </div>
                        <div class="columns" style="margin-top: -25px;">
                          <div class="column">
                            ເສຍຫາຍ-ຖິ້ມ
                            <b-input
                              v-model.trim="selectedStockProductBroken" 
                              type="number"
                              min="1"
                              pattern="[0-9]+"
                            >
                            </b-input>
                          </div>
                        </div>

                        <div class="columns" style="margin-top: -25px;">
                          <div class="column">
                            <b-button
                              class="btn-group-margin"
                              type="is-success"  
                              @click="saveStockOut()"
                              >ບັນທຶກ
                            </b-button> 
                          </div>
                        </div>
                        <div>
                          <hr style="border: none; border-top: 3px solid black; margin-top: -10px; ">
                        </div>
                        <div style="font-size:18px; font-weight: bold; margin-bottom: 10px">ໂອນສິນຄ້າໃຫ້ POS</div>    
            
                        
                        <div class="columns">
                          <div class="column">  
                            ວັນທີ
                            <b-field label="">
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="stockOutDate"
                                >  
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div>
                        </div>
                        

                        <div class="columns" style="margin-top: -25px;">   
                          <div class="column">
                            ຈຳນວນ
                            <b-input
                              v-model.trim="selectedStockProductQuantityForPOS" 
                              type="number"
                              min="1"
                              pattern="[0-9]+"
                            >
                            </b-input>
                          </div>
                        </div>
                        <div class="columns" style="margin-top: -25px;">
                          <div class="column">
                            ຈຳນວນເງິນລວມ
                            <b-input
                              v-model.trim="selectedStockProductTotalForPOS" 
                              type="number"
                              min="1"
                              pattern="[0-9]+"
                            >
                            </b-input>
                          </div>
                        </div>

                        <div class="columns" style="margin-top: -25px;">
                          <div class="column">
                            <b-button
                              class="btn-group-margin"
                              type="is-success"  
                              @click="saveStockOutForPOS()"
                              >ບັນທຶກ
                            </b-button> 
                          </div>
                        </div>

                      </div>
                      <div class="column column-80">
                        <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ປະຫວັດ ການເບີກເຄື່ອງອອກສາງ</div>      
                        <div class="columns" style="color: red;">
                          {{selectedProductOutData.ID}} - {{selectedProductOutData.PRODUCTNAME}} | {{selectedProductOutData.LOTREMAIN}} {{selectedProductOutData.UNIT}} (ລາຄາຕໍ່ໜ່ວຍຕັ້ງຕົ້ນ: {{ selectedProductOutData.TOTALPRICE/selectedProductOutData.STOCKIN | formatNumberLocal }})
                          <b-button    
                            class="btn-group-margin"
                            type="is-success"  
                            @click="reCalStockOut(selectedProductOutData.ID)"   
                            >ຄຳນວນຄືນໃໝ່   
                          </b-button>
                          
                        </div>
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="1%">
                                # 
                                
                              </th>

                              <th class="has-text-left " width="10%">
                                ວັນທີ
                              </th>
                              <th class="has-text-right " width="10%">
                                ເຄື່ອງ<br>ໃນສາງ
                              </th>
                              <th class="has-text-right " width="10%">
                                ມູນຄ່າ<br>ຕັ້ງຕົ້ນ
                              </th>
                              <th class="has-text-right " width="8%">
                              ຂາຍອອກ
                              </th>  
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ  <br>
                                ຫ້ອງການ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ 
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ <br> ລວມ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ<br>ສະສົມ
                              </th>
                              <th class="has-text-right " width="8%">
                                ຈຳນວນ<br>ຍັງເຫຼືອ
                              </th>
                              <th class="has-text-right " width="10%">
                                ລາຄາຂາຍ<br>ຕໍ່ໜ່ວຍ
                              </th>
                              <th class="has-text-right " width="10%">
                                ມູນຄ່າ<br>ຍັງເຫຼືອ
                              </th>
                              
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in productInStockUsage"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}
                                <!-- <b-button v-if="data.ID === productStockUsageMaxID && data.ISPOS ==0 " -->
                                <b-button v-if="data.ID === productStockUsageMaxID && data.SELLHISTORYID === null"       

                                    class="is-small btn-group-margin"
                                    type="is-danger"
                                    size="is-small"
                                    @click="cancelProductStockUsage(data)"        
                                >X 
                                </b-button>
                              </td>

                              <td class="has-text-left">
                                {{data.TXDATE}}
                              </td>
                              <td class="has-text-right">
                                {{  data.INSTOCK | formatNumberLocal }}
                              </td>            
                              <td class="has-text-right">
                                {{ data.VALUEREMAIN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right">
                                  {{ data.SELL | formatNumberLocal }} 
                                  <span v-if="data.ISPOS==1" style="color: red;"><br>POS</span>   
                              </td>
                  
                              <td class="has-text-right">
                                {{ data.OFFICESELL | formatNumberLocal }}
                              </td>
                              <td class="has-text-right">
                                {{ data.BROKEN | formatNumberLocal }}
                              </td>  
                              <td class="has-text-right">
                                {{ data.ALLBROKEN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right">
                                {{ data.TOTALBROKEN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right">
                                <span v-if="data.ID === productStockUsageMaxID" style="color: red; font-weight: bold;">
                                  {{ data.REMAIN | formatNumberLocal }}
                                </span>
                                <span v-else>
                                  {{ data.REMAIN | formatNumberLocal }}
                                </span>
                               
                              </td> 
                              <td class="has-text-right">  
                                <span v-if="data.ID === productStockUsageMaxID" style="color: red; font-weight: bold;">
                                  {{ data.SELLPRICE | formatNumberLocal }}
                                </span>
                                <span v-else>
                                  {{ data.SELLPRICE | formatNumberLocal }}
                                </span>
                              </td> 
                              <td class="has-text-right">
                               
                                <span v-if="data.ID === productStockUsageMaxID" style="color: red; font-weight: bold;">
                                  {{ data.REMAIN*data.SELLPRICE | formatNumberLocal }}
                                </span>
                                <span v-else>
                                  {{ data.REMAIN*data.SELLPRICE | formatNumberLocal }}
                                </span>
                              </td> 

                                                            
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="4" class="has-text-centered">
                                ລວມ
                                {{ productInStockUsage.length | formatNumberLocal }}
                                ລາຍການ
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockUsage, (i) => i["SELL"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockUsage, (i) => i["OFFICESELL"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockUsage, (i) => i["BROKEN"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockUsage, (i) => i["ALLBROKEN"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right">
                               
                              </th>
                              <th class="has-text-right">
                               
                              </th>
                              <th class="has-text-right">
                               
                              </th>
                              <th class="has-text-right">
                               
                              </th>
                            </tr>
                          </tfoot>
                          
                        </table>


                        <!-- <div style="font-size: 18px; font-weight: bold; margin-top: 30px;" v-if="productInStockOutWait.length > 0">
                          ລໍຖ້າອະນຸມັດ
                        </div>

                        <table class="table is-fullwidth is-narrow is-small" style="background-color: #f2e5b1;"  v-if="productInStockOutWait.length > 0"> 
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="10%">
                                # 
                                
                              </th>

                              <th class="has-text-left " width="10%">
                                ວັນທີ
                              </th>
                              
                              <th class="has-text-right " width="8%">
                              ຂາຍອອກ
                              </th>  
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ  <br>
                                ຫ້ອງການ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ 
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ <br> ລວມ
                              </th>
                              <th class="has-text-right " width="8%">
                                ເສຍຫາຍ<br>ສະສົມ
                              </th>
                              <th class="has-text-centered " width="10%">
                               ອະນຸມັດ
                              </th>
                             
                              
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in productInStockOutWait"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}
                                <b-button 
                                    class="is-small btn-group-margin"
                                    type="is-danger"
                                    size="is-small"
                                    @click="cancelProductStockOutWait(data)"        
                                >XX
                                </b-button>
                              </td>

                              <td class="has-text-left">
                                {{data.TXDATE}}
                              </td>
                                
                              <td class="has-text-right">
                                  {{ data.SELL | formatNumberLocal }}
                              </td>
                  
                              <td class="has-text-right">
                                {{ data.OFFICESELL | formatNumberLocal }}
                              </td>
                              <td class="has-text-right">
                                {{ data.BROKEN | formatNumberLocal }}
                              </td>  
                              <td class="has-text-right">
                                {{ data.ALLBROKEN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right">
                                {{ data.TOTALBROKEN | formatNumberLocal }}
                              </td> 
                              <td class="has-text-centered">
                                <b-button
                                  class="btn-group-margin"
                                  type="is-success"  
                                  @click="approveStockOutWait(data.ID,data.MARKETBATCHID)"
                                  >ອະນຸມັດ 
                                </b-button> 
                               
                              </td> 
                                                            
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="2" class="has-text-centered">
                                ລວມ
                                {{ productInStockOutWait.length | formatNumberLocal }}
                                ລາຍການ
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockOutWait, (i) => i["SELL"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>  
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockOutWait, (i) => i["OFFICESELL"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockOutWait, (i) => i["BROKEN"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                {{
                                  _.sumBy(productInStockOutWait, (i) => i["ALLBROKEN"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                              <th class="has-text-right">
                               
                              </th>
                            </tr>
                          </tfoot>
                          
                        </table> -->
                      </div>
                    </div>
                  </b-field>
                </div>
              </div>
            </b-tab-item>
            <b-tab-item label="ຕິດຕາມເຄື່ອງອອກສາງ (ຕາມວັນທີຊື້)">
              <div class="columns scrollme">
                <div class="column">
                  <b-field>
                    <div class="columns" style=" display: flex">
                      
                      <div class="column column">
                        <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ຕິດຕາມເຄື່ອງອອກສາງ (ຕາມວັນທີຊື້)</div>    
                        <div class="columns">
                          <div class="column">  
                            ແຕ່ວັນທີ
                            <b-field label="">
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="stockBuyStartdate"
                                >  
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div>
                          <div class="column">  
                            ເຖິງວັນທີ
                            <b-field label="">
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="stockBuyEnddate"
                                >  
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div> 

                          
                          
                          <div class="column">
                            <b-button style=" margin-top: 23px;"
                                  class="btn-group-margin is-fullwidth"  
                                  type="is-success"
                                  @click="getStockBuyDateList()"        
                              >ເບິ່ງຂໍ້ມູນ
                              </b-button>

                          </div>
                        </div> 
                        <b-tabs v-model="activeTabSub4" >
                          <b-tab-item label="ຂໍ້ມູນຕາມວັນທີ">  
                            <table class="table is-fullwidth is-narrow is-small">
                              <thead>
                                <tr>
                                  <th class="has-text-centered " width="3%">
                                    # 
                                    
                                  </th>
                                  <th class="has-text-centered " width="10%">
                                    ວັນທີຊື້
                                  </th>
                                  <th class="has-text-right " width="10%">
                                    ຈຳນວນເງິນຊື້
                                  </th>
                                  <th class="has-text-right " width="10%">
                                    ຈຳນວນເງິນຂາຍ
                                  </th>
                                  <th class="has-text-right " width="10%">
                                    ຈຳນວນເງິນເສຍຫາຍ
                                  </th>
                                  
                                  <th class="has-text-right " width="10%">
                                    ຈຳນວນເງິນຍັງເຫຼືອ
                                  </th>
                                  <th class="has-text-centered " width="10%">
                                    ຈັດການ
                                  </th>
                                  
                                  
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(data, index) in stockBuyDateList"
                                  :key="data.STOCKINDATE"   
                                >
                                  <td class="has-text-centered">{{ index + 1 }}
                                  </td>

                                  <td class="has-text-centered">
                                    {{  data.STOCKINDATE  }} 
                                  </td>
                                    
                                  <td class="has-text-right">
                                    {{  data.TOTALPRICE  | formatNumberLocal_decimal(2) }} 
                                  </td>            
                                          
                                  
                                  <td class="has-text-right">
                                      {{ data.TOTALSELL | formatNumberLocal_decimal(2) }}
                                  </td>   
                                  <td class="has-text-right">
                                    {{ data.TOTALBROKEN | formatNumberLocal_decimal(2) }}
                                  </td>
                                  
                                  <td class="has-text-right" >  
                                    
                                    {{data.TOTALPRICE- data.TOTALSELL-data.TOTALBROKEN | formatNumberLocal_decimal(2) }}
                                    
                                  </td> 
                                  <td class="has-text-right" >  
                                    <b-button
                                      style="float: right;"
                                      class="btn-group-margin"
                                      type="is-success" 
                                      @click="getStockBuyDateDetail(data.STOCKINDATE)" 
                                      > <span style=" font-family: Phetsarath OT !important ;">ລາຍລະອຽດ</span>
                                    </b-button>
                                    
                                    
                                  </td> 
                                              
                                </tr>
                              </tbody>
                              <!-- <tfoot>
                                <tr>
                                  <th colspan="4" class="has-text-right">
                                    ລວມ
                                    {{ productStockBrokenHistory_original.length | formatNumberLocal }}
                                    ລາຍການ
                                  </th>
                                  <th class="has-text-right" style="color: red; font-weight: bold;">
                                    {{  
                                      _.sumBy(productStockBrokenHistory_original, (i) =>  i["QUANTITY"] * i["UNITPRICE"] * 1)     
                                        | formatNumberLocal  
                                    }}
                                  </th>
                                  
                                </tr>
                              </tfoot> -->
                              
                            </table> 
                          </b-tab-item>
                          <b-tab-item label="ລາຍລະອຽດ">  
                            <b-field>
                              ວັນທີ: {{ selectedStockBuyDate_Date }}   
                            </b-field> 
                            <table class="table is-fullwidth is-narrow is-small">
                              <thead>
                                <tr>
                                  <th class="has-text-centered " width="3%">
                                    # 
                                    
                                  </th>
                                  <th class="has-text-right " width="10%">
                                    ສິນຄ້າ
                                  </th>
                                  <th class="has-text-right " width="5%">
                                    ຈຳນວນ
                                  </th>
                                  <th class="has-text-right " width="5%">
                                    ລາຄາ<br>ຕໍ່ໜ່ວຍ
                                  </th>
                                  <th class="has-text-right " width="5%">
                                    ຈຳນວນ<br>ເງິນຊື້
                                  </th>
                                  
                                  <th class="has-text-right " width="5%">
                                    ຂາຍ<br>ມື້1
                                  </th>
                                  <th class="has-text-right " width="5%">
                                    ຂາຍ<br>ມື້2
                                  </th>
                                  <th class="has-text-right " width="5%">
                                    ຂາຍ<br>ມື້3
                                  </th>
                                  <th class="has-text-right " width="5%">
                                    ຂາຍ<br>ມື້4
                                  </th>
                                  <th class="has-text-right " width="5%">
                                    ຂາຍ<br>ມື້5
                                  </th>
                                  <th class="has-text-right " width="5%">
                                    ຂາຍ<br>ມື້6
                                  </th>
                                  <th class="has-text-right " width="5%">
                                    ຂາຍ<br>ມື້7
                                  </th>
                                  <th class="has-text-centered " width="10%">
                                    ຂາຍ<br>ລວມ
                                  </th>
                                  <th class="has-text-centered " width="10%">
                                    ຈຳນວນ<br>ເງິນຂາຍ
                                  </th>
                                  <th class="has-text-centered " width="10%">
                                    ຈຳນວນ<br>ເສຍຫາຍ
                                  </th>
                                  <th class="has-text-centered " width="10%">
                                    ຈຳນວນເງິນ<br>ເສຍຫາຍ
                                  </th>
                                  <th class="has-text-centered " width="10%">
                                    ຈຳນວນເງິນ<br>ຍັງເຫຼືອ
                                  </th>
                                  
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(data, index) in stockBuyDateDetail"
                                  :key="data.LOTID"   
                                >
                                  <td class="has-text-centered">{{ index + 1 }}
                                  </td>

                                  <td class="has-text-left">
                                    {{  data.LOTID  }} <br>
                                    {{  data.PRODUCTNAME  }} 
                                  </td>
                                  <td class="has-text-right">
                                    {{  data.STOCKIN  | formatNumberLocal_decimal }} 
                                  </td>            
                                          
                                  <td class="has-text-right">
                                    {{ data.UNITPRICE | formatNumberLocal_decimal(2) }}
                                  </td>  
                                  <td class="has-text-right">
                                      {{ data.TOTALPRICE | formatNumberLocal }}
                                  </td>  
                                  <td class="has-text-right">
                                      {{ data.TXDATE_1 | formatNumberLocal_decimal }}
                                  </td>  
                                  <td class="has-text-right">
                                      {{ data.TXDATE_2 | formatNumberLocal }}
                                  </td>  
                                  <td class="has-text-right">
                                      {{ data.TXDATE_3 | formatNumberLocal}}
                                  </td>  
                                  <td class="has-text-right">
                                      {{ data.TXDATE_4 | formatNumberLocal }}
                                  </td>  
                                  <td class="has-text-right">
                                      {{ data.TXDATE_5 | formatNumberLocal_decimal }}
                                  </td>  
                                  <td class="has-text-right">
                                      {{ data.TXDATE_6 | formatNumberLocal }}
                                  </td>  
                                  <td class="has-text-right">
                                      {{ data.TXDATE_7 | formatNumberLocal }}
                                  </td>  



                                  <td class="has-text-right" v-if="data.ALLSELL !=data.SELLQUANTITY " style="background-color: red; color: white">
                      
                                      {{ data.ALLSELL | formatNumberLocal }}<br>
                                      {{ data.SELLQUANTITY | formatNumberLocal }}
        
                                  </td>
                                  <td class="has-text-right" v-else>
                                     
                                      {{ data.ALLSELL | formatNumberLocal }}   
                              
                                  </td>  



                                  <td class="has-text-right">
                                   
                                      {{ data.TOTALSELL | formatNumberLocal_decimal(2) }}
                                  </td>   
                                  <td class="has-text-right">
                                      {{ data.BROKENQUANTITY | formatNumberLocal }}
                                  </td>  
                                  <td class="has-text-right">
                                      {{ data.TOTALBROKEN | formatNumberLocal_decimal(2) }}
                                  </td>  
                                  <td class="has-text-right">
                                      {{ data.TOTALPRICE-data.TOTALSELL-data.TOTALBROKEN | formatNumberLocal_decimal(2) }}  
                                  </td>  
                                  
                                 
                                              
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <th colspan="4" class="has-text-right">
                                    ລວມ
                                    {{ stockBuyDateDetail.length | formatNumberLocal }}
                                    ລາຍການ
                                  </th>
                                  <th class="has-text-right" style="color: red; font-weight: bold;">
                                    {{  
                                      _.sumBy(stockBuyDateDetail, (i) =>  i["TOTALPRICE"]* 1)     
                                        | formatNumberLocal_decimal(2)    
                                    }}
                                  </th>
                                  <th colspan="8">
                                   
                                  </th>
                                  <th class="has-text-right" style="color: red; font-weight: bold;">
                                    {{  
                                      _.sumBy(stockBuyDateDetail, (i) =>  i["TOTALSELL"]* 1)     
                                        | formatNumberLocal_decimal(2)    
                                    }}
                                  </th>
                                  <th >
                                   
                                  </th>
                                  <th class="has-text-right" style="color: red; font-weight: bold;">
                                    {{  
                                      _.sumBy(stockBuyDateDetail, (i) =>  i["TOTALBROKEN"]* 1)     
                                        | formatNumberLocal_decimal(2)  
                                    }}
                                  </th>
                                  <th class="has-text-right" style="color: red; font-weight: bold;">
                                    {{  
                                      _.sumBy(stockBuyDateDetail, (i) =>  (i["TOTALPRICE"]-i["TOTALSELL"]-i["TOTALBROKEN"])* 1)  
                                        | formatNumberLocal_decimal(2)  
                                    }}
                                  </th>
                                  
                                </tr>
                              </tfoot>
                              
                            </table> 
                          </b-tab-item>
                        </b-tabs>
                            

                        
                      </div>
                    </div>
                  </b-field>
                </div>
              </div>
            </b-tab-item>
            <b-tab-item label="ຕິດຕາມເຄື່ອງອອກສາງ (ເສຍຫາຍ)">
              <div class="columns scrollme">
                <div class="column">
                  <b-field>
                    <div class="columns" style=" display: flex">
                      
                      <div class="column column">
                        <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ຕິດຕາມເຄື່ອງອອກສາງ (ເສຍຫາຍ)</div>    
                        <div class="columns">
                          <div class="column">  
                            ແຕ່ວັນທີ
                            <b-field label="">
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="stockBrokenStartDate"
                                >  
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div>
                          <div class="column">  
                            ເຖິງວັນທີ
                            <b-field label="">
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="stockBrokenEndDate"
                                >  
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div> 

                          
                          
                          <div class="column">
                            <b-button style=" margin-top: 23px;"
                                  class="btn-group-margin is-fullwidth"  
                                  type="is-success"
                                  @click="getProductStockBrokenHistory(1)"        
                              >ຕາມສິນຄ້າ
                              </b-button>

                          </div>
                          <div class="column">
                            <b-button style=" margin-top: 23px;"
                                    class="btn-group-margin is-fullwidth"
                                    type="is-primary"
                                    @click="getProductStockBrokenHistory(2)"         
                                >ຕາມ LOT
                                </b-button>

                              <b-field style="padding-left: 5px;">    
                                <Multiselect
                                    placeholder="ເລືອກສິນຄ້າ"  
                                    v-model.trim="selectedProductStockBroken"
                                    label="PRODUCTNAME"
                                    track-by="PRODUCTID"
                                    :options="productStockBrokenList"
                                    @input="onSelectProductStockBroken"
                                >
                                </Multiselect>
                              </b-field>
                            

                          </div>
                        </div> 
                        <div class="columns" v-if="brokentype==1">
                          <div class="column">
                            <table class="table is-fullwidth is-narrow is-small" >
                              <thead>
                                <tr>
                                  <th class="has-text-centered " width="3%">
                                    # 
                                    
                                  </th>
                                  <th class="has-text-left " width="30%">
                                    ສິນຄ້າ
                                  </th>
                                  <!-- <th class="has-text-right " width="10%">
                                    ຈຳນວນເສຍຫາຍ 
                                  </th> -->
                                  <th class="has-text-right " width="10%"
                                    @click="sortDateData('QUANTITY', 'desc')" 
                                    style="cursor: pointer; color: blue; text-decoration: underline;">
                                    ຈຳນວນເສຍຫາຍ
                                  </th>
                                  <!-- <th class="has-text-right " width="10%">
                                    ມູນຄ່າຕໍ່ໜ່ວຍ
                                  </th>  -->
                                  <th class="has-text-right " width="10%"
                                    @click="sortDateData('UNITPRICE', 'desc')" 
                                    style="cursor: pointer; color: blue; text-decoration: underline;">
                                    ມູນຄ່າຕໍ່ໜ່ວຍ
                                  </th> 
                                  <!-- <th class="has-text-right " width="15%">
                                    ລວມເປັນເງິນ
                                  </th> -->
                                  <th class="has-text-right " width="15%"
                                    @click="sortDateData('TOTAL', 'desc')" 
                                    style="cursor: pointer; color: blue; text-decoration: underline;">  
                                    ລວມເປັນເງິນ
                                  </th>
                                  
                                  
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(data, index) in productStockBrokenHistory_original"
                                  :key="data.ID"   
                                >
                                  <td class="has-text-centered">{{ index + 1 }}
                                  </td>

                                  <td class="has-text-left">
                                    {{  data.PRODUCTNAME }} ({{ data.UNIT }})
                                  </td>            
                                          
                                  <td class="has-text-right">
                                    {{ data.QUANTITY | formatNumberLocal }}
                                  </td>  
                                  <td class="has-text-right" style="color: red;">
                                      {{ data.UNITPRICE | formatNumberLocal }}
                                  </td>   
                                  
                                  <td class="has-text-right" style="color: red;">  
                                    
                                    {{ (data.QUANTITY*data.UNITPRICE) | formatNumberLocal }}
                                    
                                  </td> 
                                              
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <th colspan="4" class="has-text-right">
                                    ລວມ
                                    {{ productStockBrokenHistory_original.length | formatNumberLocal }}
                                    ລາຍການ
                                  </th>
                                  <th class="has-text-right" style="color: red; font-weight: bold;">
                                    {{  
                                      _.sumBy(productStockBrokenHistory_original, (i) =>  i["QUANTITY"] * i["UNITPRICE"] * 1)     
                                        | formatNumberLocal  
                                    }}
                                  </th>
                                  
                                </tr>
                              </tfoot>
                              
                            </table>
                        
                          </div>
                        </div>

                        <div v-else-if="brokentype==2">
                          <div class="columns" >
                            <div class="column">
                            
                            </div>
                            <div class="column">
                              
                            </div>
                            <div class="column">
                              
                            </div>
                            <div class="column" style="float: right;">
                              <b-button           
                                class="btn-group-margin is-fullwidth"
                                type="is-info" 
                                @click="printStockBroken()"   
                                >ພິມລາຍການເສຍຫາຍ
                              </b-button> 
                            </div>   
                          </div>

                          <table class="table is-fullwidth is-narrow is-small" >
                            <thead>
                              <tr>
                                <th class="has-text-centered " width="3%">
                                  # 
                                  
                                </th>
                                <th class="has-text-centered " width="10%">
                                  ວັນທີ
                                </th>
                                <th class="has-text-left " width="30%">
                                  ສິນຄ້າ
                                </th>
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນເສຍຫາຍ 
                                </th>
                                <th class="has-text-right " width="10%">
                                  ມູນຄ່າຕໍ່ໜ່ວຍ
                                </th>
                                <th class="has-text-right " width="15%">
                                  ລວມເປັນເງິນ
                                </th>
                                
                                
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(data, index) in productStockBrokenHistory"
                                :key="data.ID"   
                              >
                                <td class="has-text-centered">{{ index + 1 }}
                                </td>

                                <td class="has-text-centered">
                                  {{data.TXDATE}}
                                </td>
                                <td class="has-text-left">
                                  <span style="color: red;">{{data.LOTID}}</span> {{  data.PRODUCTNAME }} ({{ data.UNIT }})<br> {{data.LOTTXDATE}}
                                </td>            
                                        
                                <td class="has-text-right">
                                  {{ data.LOT_QUANTITY | formatNumberLocal }}
                                </td>  
                                <td class="has-text-right" style="color: red;">
                                    {{ data.UNITPRICE | formatNumberLocal }}
                                </td>
                                
                                <td class="has-text-right" style="color: red;">  
                                  
                                    {{ (data.LOT_QUANTITY*data.UNITPRICE) | formatNumberLocal }}
                                  
                                </td> 
                                            
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <th colspan="3" class="has-text-right">
                                  ລວມ
                                  {{ productStockBrokenHistory.length | formatNumberLocal }}
                                  ລາຍການ
                                </th>
                                <th class="has-text-right" style="color: red; font-weight: bold;">
                                  {{  
                                    _.sumBy(productStockBrokenHistory, (i) => i["LOT_QUANTITY"] * 1)   
                                      | formatNumberLocal  
                                  }}
                                </th>
                                <th class="has-text-right" style="color: red; font-weight: bold;">
                                  
                                </th>
                                <th class="has-text-right" style="color: red; font-weight: bold;">  
                                  {{  
                                    _.sumBy(productStockBrokenHistory, (i) => i["LOT_QUANTITY"] * i["UNITPRICE"] * 1)      
                                      | formatNumberLocal  
                                  }}
                                </th>
                                
                              </tr>
                            </tfoot>
                            
                          </table>
                        </div>
                       

                          
                      </div>
                    </div>
                  </b-field>
                </div>
              </div>
            </b-tab-item>

            <b-tab-item label="ຕິດຕາມເຄື່ອງອອກສາງ (ອອກໃບຮຽກເກັບ)">
              <div class="columns scrollme">
                <div class="column">
                  <b-field>
                    <div class="columns" style=" display: flex">
                      
                      <div class="column column">
                        <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ການເບີກເຄື່ອງອອກສາງ (ອອກໃບຮຽກເກັບ)</div>    
                        <div class="columns">
                          <div class="column">  
                            ວັນທີ
                            <b-field label="">
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="productStockOutTxdateByProduct"
                                >  
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div>
                          <div class="column">
                            ພາກສ່ວນ  
                            <b-field >
                                <Multiselect
                                  placeholder="ພາກສ່ວນ"  
                                  v-model.trim="selectedSection"
                                  label="NAME"
                                  track-by="ID"
                                  :options="stockSectionList"
                                >
                                </Multiselect>
                              </b-field>
                          </div>
                          <div class="column">
                            <b-button style=" margin-top: 23px;"
                                    class="btn-group-margin"
                                    type="is-primary"
                                    @click="getProductStockOutHistoryByProduct()"        
                                >ເບິ່ງຂໍ້ມູນ
                                </b-button>
                            

                          </div>
                        </div> 
                        
                        <div class="columns">
                          <div class="column">
                            <div style="margin-top: -10px; font-size: 18px;" v-if="productStockOutHistoryByProduct.length > 0">   
                                ວັນທີ: {{ dateFormatter(productStockOutHistoryByProduct[0].TXDATE) }} 
                            </div>
                          </div>
                          <div class="column" style="float: right;">
                            <b-button           
                              class="btn-group-margin is-fullwidth"
                              type="is-info" 
                              @click="printStockOInvoice()"   
                              >ພິມໃບຮຽກເກັບ
                            </b-button> 
                          </div>   
                          
                          <div class="column" style="float: right;">
                            <b-button v-if="accountStatus ==0 && selectedSectionID !=2"          
                              class="btn-group-margin is-fullwidth"
                              type="is-warning" 
                              @click="cancelStockSellUnitPriceAll()"   
                              >ລືບຂໍ້ມູນທັງໝົດ
                            </b-button> 
                          </div>  
                          <div class="column" style="float: right;">
                            <b-button v-if="accountStatus ==0 && selectedSectionID !=2"          
                              class="btn-group-margin is-fullwidth"
                              type="is-success" 
                              @click="saveStockSellUnitPriceAll()"   
                              >ບັນທຶກລາຄາ ແລະ ສົ່ງຂໍ້ມູນທັງໝົດ
                            </b-button> 
                          </div>     
                                                
                        </div>
                        <table class="table is-fullwidth is-narrow is-small" v-if="selectedSectionID !=2">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="3%">
                                # 
                                
                              </th>
                              <th class="has-text-left " width="5%">  
                                ພາກສ່ວນ
                              </th>
                              <th class="has-text-left " width="15%">
                                ສິນຄ້າ
                              </th>
                              <th class="has-text-right " width="10%">
                                ຈຳນວນ
                              </th>
                              <th class="has-text-right " width="8%">
                                ຕົ້ນທືນ<br>ຕໍ່ໜ່ວຍ
                              </th>
                              <th class="has-text-right " width="8%">
                                ລວມຕົ້ນທືນ
                              </th>
                              <th class="has-text-right " width="8%">
                                ລາຄາລ່າສຸດ
                              </th>
                              <th class="has-text-centered " width="10%">
                                ລາຄາຂາຍ<br>ຕໍ່ໜ່ວຍ
                              </th>
                              <th class="has-text-right " width="8%">
                                ລວມ<br>ເງິນຂາຍ
                              </th>
                              <th class="has-text-right " width="8%">  
                                ເປີເຊັນກຳໄລ<br>ຕໍ່ໜ່ວຍ
                              </th>
                              <th class="has-text-right " width="8%">  
                                ລວມກຳໄລ<br>ສ່ວນຕ່າງ
                              </th>
                              <th class="has-text-right " width="5%">
                                ຈັດການ
                              </th>
                              
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in productStockOutHistoryByProduct"
                              :key="data.ID"
                              :style="{ backgroundColor:data.MULTIPLY >1  ? 'yellow' : '' }"  
                              
                            >
                              <td class="has-text-centered">{{ index + 1 }}      
                              </td>
                              <td class="has-text-left">
                                <span v-if="data.ISPOS==1">Stock POS</span>
                                <span v-else>ອອກຕະຫຼາດ</span>
                              </td>
                              
                              <td class="has-text-left">
                                <!-- {{  data.PRODUCTNAME }} ({{ data.UNIT }})  <br>  -->
                                {{ data.OKPRODUCTNAME }} 
                              </td>  
                              <td class="has-text-right" > 
                                  <!-- {{ data.QUANTITY }}<br>      -->
                                  <!-- {{ data.OKQUANTITY0 }}<br>            -->
                                  <span style="color: red;">{{ data.OKQUANTITY}} </span>
                                   <!-- {{ data.OKUNIT }} -->
                              </td>     
                              
                              <td class="has-text-right" >  
                                
                                  {{ data.UNITPRICE*data.MULTIPLY | formatNumberLocal }}
                                
                              </td> 
                              <td class="has-text-right" >  
                              
                                  {{ data.UNITPRICE*data.OKQUANTITY*data.MULTIPLY | formatNumberLocal }}
                             
                              </td>
                              <td class="has-text-right" >  
                                <span v-if="accountStatus ==0">
                                  <span style="font-weight: bold;">{{ data.PRICE_UNITPRICE | formatNumberLocal }}</span>  <br>    
                                  <span v-if="data.PRICE_DATE">
                                    {{ dateFormatter(data.PRICE_DATE) }}  
                                  </span>

                                  
                                </span>
                                  
                                
                              </td>
                              <td class="has-text-right" >  
                                <b-field v-if="selectedSectionID !=2">
                                  <b-field v-if="accountStatus ==0" style=" display: flex; flex-direction: column; align-items: flex-end;">
                                    <div>
                                      <b-input style="float: right; width: 120px;" 
                                        v-model.trim="data.OKSELLUNITPRICE"  
                                        type="number"
                                        min="1"
                                        pattern="[0-9]+"    
                                      >     
                         
                                      </b-input> 
                                       
                                    </div>  
                                    <div style="text-align: right;">
                                      ກຳໄລ: 
                                      <span style="color: red;">
                                        {{ data.OKSELLUNITPRICE - (data.UNITPRICE * data.MULTIPLY) | formatNumberLocal }}
                                      </span>
                                    </div> 
                                  </b-field>
                                  <b-field v-else style=" display: flex; flex-direction: column; align-items: flex-end;">
                                    <div v-if="data.SELLHISTORYID" style="">  
                                      {{ data.OKSELLUNITPRICE | formatNumberLocal }}     
                                    </div>
                                    <div v-if="data.OKSELLUNITPRICE > 0">  
                                      <span v-if="data.SELLHISTORYID">
                                        ກຳໄລ: <span style="color: red;">{{ data.STOCKSELLUNITPRICE - (data.UNITPRICE*data.MULTIPLY) | formatNumberLocal}}</span>
                                      </span>
                                      <span v-if="data.SELLHISTORYID == null && accountStatus ==0">
                                        ກຳໄລ: <span style="color: red;">{{ data.OKSELLUNITPRICE - (data.UNITPRICE*data.MULTIPLY) | formatNumberLocal}}</span>
                                      </span>
                                    </div>

                                  </b-field>
                                  
                                 
                                    
                                 
                                </b-field>
                                <!-- <b-field>
                                  {{ data.OKSELLUNITPRICE | formatNumberLocal }}<br>
                                  ກຳໄລ: <span style="color: red;">{{ data.OKSELLUNITPRICE - (data.UNITPRICE*data.MULTIPLY) | formatNumberLocal}}</span>
                                </b-field> -->
                                  
                                  
                                  
                              </td> 
                              <td class="has-text-right" style="color: red ;">
                                <b-field v-if="selectedSectionID !=2">
                                  <span v-if="data.OKSELLUNITPRICE > 0">
                                    <span v-if="data.SELLHISTORYID">
                                      {{ Math.ceil(data.STOCKSELLUNITPRICE * data.OKQUANTITY) | formatNumberLocal }}<br>
                                    </span>
                                    <span v-if="data.SELLHISTORYID== null && accountStatus ==0">
                                      {{ Math.ceil(data.OKSELLUNITPRICE * data.OKQUANTITY) | formatNumberLocal }}<br>
                                    </span> 

                                    <b-button v-if="data.OKQUANTITY - data.OKQUANTITY == 0 && accountStatus ==0 && data.STOCKSELLUNITPRICE != null"    
                                      class="btn-group-margin"
                                      type="is-danger"    
                                      size="is-small"  
                                      @click="cancelStockSellUnitPrice(index,2)"          
                                      >ລຶບຂໍ້ມູນ
                                    </b-button>

                                    <b-button v-if="data.OKQUANTITY - data.OKQUANTITY != 0 && accountStatus ==0 && data.STOCKSELLUNITPRICE != null"    
                                      class="btn-group-margin"
                                      type="is-danger"    
                                      size="is-small"  
                                      @click="cancelStockSellUnitPrice(index,1)"          
                                      >ລຶບຂໍ້ມູນ
                                    </b-button>

                                  </span>
                                </b-field>
                                <b-field v-else>
                                  <!-- <span v-if="data.SELLHISTORYID== null && accountStatus ==0"> -->
                                      {{ Math.ceil(data.OKSELLUNITPRICE * data.OKQUANTITY) | formatNumberLocal }}<br>
                                  <!-- </span>  -->
                                </b-field>
                                  
                              </td>     

                              <td class="has-text-right" >  
                                <span v-if="data.SELLHISTORYID">
                                 <span style="color: red;">{{ (data.STOCKSELLUNITPRICE - (data.UNITPRICE*data.MULTIPLY))/(data.UNITPRICE*data.MULTIPLY )*100 | formatNumberLocal_decimal(2)}}% </span>   
                                </span>
                                <span v-if="data.SELLHISTORYID == null && accountStatus ==0">
                                 <span style="color: red;">{{ (data.OKSELLUNITPRICE - (data.UNITPRICE*data.MULTIPLY))/(data.UNITPRICE*data.MULTIPLY )*100 | formatNumberLocal_decimal(2)}}%</span>  
                                </span>
                                                          
                                   
                              </td>

                              <td class="has-text-right" :style="{ backgroundColor: (data.OKSELLUNITPRICE * data.OKQUANTITY) - (data.UNITPRICE*data.OKQUANTITY*data.MULTIPLY) < 0  ? 'black' : '',
                                                                   color: (data.OKSELLUNITPRICE * data.OKQUANTITY) - (data.UNITPRICE*data.OKQUANTITY*data.MULTIPLY) < 0  ? 'white' : ''
                               }">  
                                <span v-if="data.OKSELLUNITPRICE > 0">
                                    {{ Math.ceil(data.OKSELLUNITPRICE * data.OKQUANTITY) - (data.UNITPRICE*data.OKQUANTITY*data.MULTIPLY)  | formatNumberLocal }} 
                                </span>
                                                                
                                
                              </td>

                              <td class="has-text-right">  
                                <b-field v-if="selectedSectionID !=2">
                                  <b-button v-if="((data.OKQUANTITY - data.OKQUANTITY == 0 || (data.OKQUANTITY - data.OKQUANTITY !=0 && data.COUNTOKPRODUCT == 1))  && data.OKSELLOUTUNITPRICE == null 
                                                  && accountStatus ==0 && data.STOCKSELLUNITPRICE == null) || ((data.OKSELLUNITPRICE != data.STOCKSELLUNITPRICE && data.STOCKSELLUNITPRICE != null) && accountStatus ==0)"          
                                    class="btn-group-margin"
                                    type="is-danger"  
                                    size="is-small"
                                    @click="saveStockSellUnitPrice(index,2)"   
                                    >ບັນທຶກລາຄາ ແລະ ສົ່ງຂໍ້ມູນ
                                  </b-button>
                                  <b-button v-else-if="(data.OKQUANTITY - data.OKQUANTITY == 0 || (data.OKQUANTITY - data.OKQUANTITY !=0 && data.COUNTOKPRODUCT == 1))  && data.OKSELLOUTUNITPRICE == null 
                                                      && accountStatus ==0 && data.STOCKSELLUNITPRICE != null"   
                                    class="btn-group-margin"
                                    type="is-success"    
                                    size="is-small"
                                    @click="saveStockSellUnitPrice(index,2)"
                                    >ບັນທຶກລາຄາ ແລະ ສົ່ງຂໍ້ມູນ    
                                  </b-button>
                                  <b-button v-else-if="(data.OKQUANTITY - data.OKQUANTITY !=0 && data.OKSELLOUTUNITPRICE == null  && accountStatus ==0 && data.STOCKSELLUNITPRICE == null) 
                                                        || ((data.OKSELLUNITPRICE != data.STOCKSELLUNITPRICE && data.STOCKSELLUNITPRICE != null) && accountStatus ==0)"       
                                    class="btn-group-margin"    
                                    type="is-danger"  
                                    size="is-small"
                                    @click="saveStockSellUnitPrice(index,1)"
                                    >ບັນທຶກລາຄາຢ່າງດຽວ
                                  </b-button>
                                  <b-button v-else-if="data.OKQUANTITY - data.OKQUANTITY !=0 && data.OKSELLOUTUNITPRICE == null  && accountStatus ==0 && data.STOCKSELLUNITPRICE != null"  
                                    class="btn-group-margin"
                                    type="is-success"  
                                    size="is-small"
                                    @click="saveStockSellUnitPrice(index,1)"
                                    >ບັນທຶກລາຄາຢ່າງດຽວ
                                  </b-button>
                                  <span v-else-if="(data.OKQUANTITY - data.OKQUANTITY == 0 || (data.OKQUANTITY - data.OKQUANTITY !=0 && data.COUNTOKPRODUCT == 1))  && data.OKSELLOUTUNITPRICE != null">
                                    {{ data.OKSELLOUTUNITPRICE }} <br> ບັນທຶກ ແລະ ສົ່ງຂໍ້ມູນແລ້ວ  
                                  </span>
                                  <span v-else-if="data.OKQUANTITY - data.OKQUANTITY !=0 && data.OKSELLOUTUNITPRICE != null">
                                    {{ data.OKSELLOUTUNITPRICE }} <br> ບັນທຶກລາຄາຢ່າງດຽວແລ້ວ
                                  </span>

                                  <span v-if="accountStatus !=0" style="color: red;">
                                    ຜູ້ຊື້ສະຫຼຸບບັນຊີແລ້ວ
                                  </span>
                                </b-field>                                  
                               
                              </td>  
                                          
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="5" class="has-text-right">
                                ລວມ
                                {{ productStockOutHistoryByProduct.length | formatNumberLocal }}  
                                ລາຍການ
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                  {{  
                                    _.sumBy(productStockOutHistoryByProduct, (i) => i["UNITPRICE"] * i["OKQUANTITY"] * i["MULTIPLY"] * 1)
                                      | formatNumberLocal  
                                  }}
                 
                        
                              </th>
                              <th colspan="2" class="has-text-right">
                              
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                <span v-if="accountStatus==0">
                                  {{  
                                    _.sumBy(productStockOutHistoryByProduct, (i) => i["OKSELLUNITPRICE"] * i["OKQUANTITY"] * 1)
                                      | formatNumberLocal  
                                  }}
                                </span>
                                <span v-else>
                                  {{  
                                    _.sumBy(productStockOutHistoryByProduct, (i) => i["STOCKSELLUNITPRICE"] * i["OKQUANTITY"] * 1)   
                                      | formatNumberLocal  
                                  }}
                                </span>
                                
                              </th>
                              <!--  {{ Math.ceil(data.OKSELLUNITPRICE * data.QUANTITY) - data.UNITPRICE*data.QUANTITY  | formatNumberLocal }} 
                                </span> -->
                              <!-- <th colspan="2" class="has-text-right">
                               
                              </th> -->
                              <th  class="has-text-right">
                         
                                  {{  
                                    _.sumBy(productStockOutHistoryByProduct, (i) => (i["OKSELLUNITPRICE"] * i["OKQUANTITY"] * 1) - ( i["OKSELLUNITPRICE"] > 0 ? (i["UNITPRICE"] * i["MULTIPLY"] * i["OKQUANTITY"] * 1 ): 0)   )  
                                      | formatNumberLocal  
                                  }}
                         
                                  
                              </th>
                              <th  class="has-text-right">
                               
                              </th>
                              
                            </tr>
                          </tfoot>
                          
                        </table>

                        <table class="table is-fullwidth is-narrow is-small" v-if="selectedSectionID ==2">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="3%">
                                # 
                                
                              </th>
                              <th class="has-text-left " width="5%">  
                                ພາກສ່ວນ
                              </th>
                              <th class="has-text-left " width="15%">
                                ສິນຄ້າ
                              </th>
                              <th class="has-text-right " width="10%">
                                ຈຳນວນ
                              </th>
                              <th class="has-text-right " width="8%">
                                ຕົ້ນທືນ<br>ຕໍ່ໜ່ວຍ
                              </th>
                              <th class="has-text-right " width="8%">
                                ລວມຕົ້ນທືນ
                              </th>
                              <th class="has-text-centered " width="10%">
                                ລາຄາຂາຍ<br>ຕໍ່ໜ່ວຍ
                              </th>
                              <th class="has-text-right " width="8%">
                                ລວມ<br>ເງິນຂາຍ
                              </th>
                              <th class="has-text-right " width="8%">  
                                ລວມກຳໄລ<br>ສ່ວນຕ່າງ
                              </th>
                              <th class="has-text-right " width="5%">
                                ຈັດການ
                              </th>
                              
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in productStockOutHistoryByProduct" :key="data.ID"
                              
                            >
                              <td class="has-text-centered">{{ index + 1 }}      
                              </td>
                              <td class="has-text-left">
                                <span v-if="data.ISPOS==1">Stock POS</span>
                                <span v-else>ອອກຕະຫຼາດ</span>
                              </td>
                              
                              <td class="has-text-left">
                                {{ data.PRODUCTNAME }} 
                              </td>  
                              <td class="has-text-right" >
                                  <span style="color: red;">{{ data.QUANTITY}} </span> {{ data.UNIT }}
                              </td>     
                              
                              <td class="has-text-right" >  
                                
                                  {{ data.UNITPRICE | formatNumberLocal }}
                                
                              </td> 
                              <td class="has-text-right" >  
                              
                                  {{ data.UNITPRICE*data.QUANTITY| formatNumberLocal }}
                             
                              </td>
                             
                              <td class="has-text-right" >  
                                {{ data.UNITPRICE | formatNumberLocal }}
                              </td> 
                              <td class="has-text-right" >  
                              
                                {{ data.UNITPRICE*data.QUANTITY| formatNumberLocal }}
                          
                            </td>
                              <td class="has-text-right" style="color: red ;">
                                
                                     ---
                                  
                              </td>     

                              
                                          
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="5" class="has-text-right">
                                ລວມ
                                {{ productStockOutHistoryByProduct.length | formatNumberLocal }}  
                                ລາຍການ
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                                  {{  
                                    _.sumBy(productStockOutHistoryByProduct, (i) => i["UNITPRICE"] * i["QUANTITY"]  * 1)
                                      | formatNumberLocal  
                                  }}
                 
                         
                              </th>
                              <th class="has-text-right">
                              
                              </th>
                              <th class="has-text-right" style="color: red; font-weight: bold;">
                               
                                  {{  
                                    _.sumBy(productStockOutHistoryByProduct, (i) => i["UNITPRICE"] * i["QUANTITY"] * 1)
                                      | formatNumberLocal  
                                  }}
                               
                                
                              </th>
                              <th  class="has-text-right">
                         
                                <!-- {{  
                                    _.sumBy(productStockOutHistoryByProduct, (i) => i["UNITPRICE"] * i["QUANTITY"] * 1)
                                      | formatNumberLocal  
                                  }} -->

                                  ---
                         
                                  
                              </th>
                              <th  class="has-text-right">
                               
                              </th>
                              
                            </tr>
                          </tfoot>
                          
                        </table>

                      </div>
                    </div>
                  </b-field>
                </div>
              </div>
            </b-tab-item>
            <b-tab-item label="ລາຍງານການຂາຍສິນຄ້າ">
              <div class="columns scrollme">
                <div class="column">
                  <b-field>
                    <div class="columns" style=" display: flex">
                      
                      <div class="column column">
                        <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ລາຍງານການຂາຍສິນຄ້າ</div>    
                        <div class="columns">
                          <div class="column">  
                            ແຕ່ວັນທີ
                            <b-field label="">
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="stockSellStartdate"
                                >  
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div>
                          <div class="column">  
                            ເຖິງວັນທີ
                            <b-field label="">
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="stockSellEnddate"
                                >  
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div> 
                          <div class="column">

                          </div>
                          
                          
                          <div class="column">
                            <b-button style=" margin-top: 23px;"
                                  class="btn-group-margin is-fullwidth"  
                                  type="is-success"
                                  @click="getStockSellReport()"        
                              >ລາຍງານ
                              </b-button>

                          </div>
                          
                        </div> 
                        

                        <table class="table is-fullwidth is-narrow is-small" >
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="3%">
                                # 
                                
                              </th>
                              <th class="has-text-centered " width="10%">
                                ວັນທີ
                              </th>
                              <th class="has-text-right " width="10%">
                                ຈຳນວນສິນຄ້າ
                              </th>
                              <th class="has-text-right " width="20%">
                                ຕົ້ນທຶນ
                              </th>
                              <th class="has-text-right " width="20%">
                                ຍອດຂາຍ 
                              </th>
                              <th class="has-text-right " width="20%">
                                ກຳໄລ
                              </th>
                              <th class="has-text-right " width="20%">
                                ເປີເຊັນ
                              </th>
                              
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in stockSellReport"
                              :key="data.ID"   
                            >
                              <td class="has-text-centered">{{ index + 1 }}
                              </td>

                              <td class="has-text-centered">
                                {{data.TXDATE}}
                              </td>
                              <td class="has-text-right">  
                                {{ data.COUNT | formatNumberLocal }}
                              </td>            
                                      
                              <td class="has-text-right">
                                {{ data.TOTALCAPITAL | formatNumberLocal_decimal(2) }}
                              </td>  
                              <td class="has-text-right" >
                                  {{ data.TOTALPRICE | formatNumberLocal_decimal(2) }}
                              </td>
                              
                              <td class="has-text-right" >
                                  {{ data.PROFIT | formatNumberLocal_decimal(2) }}
                              </td>
                              
                              <td class="has-text-right">  
                                
                                  {{ data.PROFIT_PRECENTAGE | formatNumberLocal_decimal(2) }}%
                                
                              </td> 
                                          
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="3" class="has-text-right">
                                ລວມ
                                {{ stockSellReport.length | formatNumberLocal }}
                                ລາຍການ
                              </th>
                              <th class="has-text-right" style=" font-weight: bold;">
                                {{  
                                  _.sumBy(stockSellReport, (i) => i["TOTALCAPITAL"] * 1)   
                                    | formatNumberLocal_decimal(2)  
                                }}
                              </th>
                              <th class="has-text-right" style=" font-weight: bold;">  
                                {{  
                                  _.sumBy(stockSellReport, (i) => i["TOTALPRICE"] * 1)   
                                    | formatNumberLocal_decimal(2)  
                                }}
                              </th>
                              <th class="has-text-right" style=" font-weight: bold;">
                                {{  
                                  _.sumBy(stockSellReport, (i) => i["PROFIT"] * 1)   
                                    | formatNumberLocal_decimal(2)  
                                }}
                              </th>
                              <th class="has-text-right" style=" font-weight: bold;">
                                {{  
                                  (_.sumBy(stockSellReport, (i) => i["PROFIT"] * 1)   /_.sumBy(stockSellReport, (i) => i["TOTALCAPITAL"] * 1))*100   | formatNumberLocal_decimal(2)  
                                }}%
                              </th>
                              
                            </tr>
                          </tfoot>
                          
                        </table>
                      </div>
                    </div>
                  </b-field>
                </div>
              </div>
            </b-tab-item>
          </b-tabs>

        </b-tab-item>

        <b-tab-item label="ເພີ່ມລາຍການສິນຄ້າ">
          <div class="columns">
            <div class="column" >
              <b-field>
                <div class="columns" style=" display: flex">
                  <div class="column column-40" style="padding-right: 80px;">
                    <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ຟອມເພີ່ມລາຍການສິນຄ້າ ເຂົ້າລະບົບສາງ</div>    
                    <div class="columns">
                      <div class="column">   
                        ຜູ້ສະໜອງ
                        <b-field label="">
                          <Multiselect
                            placeholder="ເລືອຜູ້ສະໜອງ"
                            v-model.trim="selectedStockProductVender"
                            label="NAME"
                            track-by="ID"
                            :options="stockVenderList"
                          >
                          </Multiselect>
                        </b-field>
                      </div>
                    </div>
                    
                    <div class="columns">
                      <div class="column">
                        ສິນຄ້າ
                        <b-field label="">
                          <Multiselect
                            placeholder="ເລືອກສິນຄ້າ"
                            v-model.trim="selectedFProduct"
                            label="NAME"
                            track-by="ID"
                            :options="fProductList"
                          >
                          </Multiselect>
                        </b-field>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column">
                        <b-button
                          class="btn-group-margin"
                          type="is-success"  
                          @click="saveProductToStock()"
                          >ບັນທຶກ
                        </b-button> 
                      </div>
                    </div>

                  </div>
                  <div class="column column-60">
                    <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ລາຍການສິນຄ້າໃນລະບົບສາງ</div>    
                    <div class="columns">
                      <div class="column" style="padding-right:50px;">
                       
                      </div>

                      <div class="column" style="padding-right:50px;">
                        <b-field label="">
                          <Multiselect
                            placeholder="ເລືອຜູ້ສະໜອງ"
                            v-model.trim="selectedStockVender"
                            label="NAME"
                            track-by="ID"
                            :options="stockVenderList"
                            @input="getStockVenderProduct"

                          >
                          </Multiselect>
                        </b-field>
                      </div> 
                    
                    </div>
                    <table class="table is-fullwidth is-narrow is-small">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="3%">#</th>

                          <th class="has-text-left " width="10%">
                            ຜູ້ສະໜອງ
                          </th>
                          <th class="has-text-left " width="20%">
                            ສິນຄ້າ
                          </th>
                      
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in stockVenderProductList"
                          :key="data.ID"
                        >

                          <td>
                            {{index + 1}}
                          </td>
                          <td class="has-text-left">
                            {{  data.VENDERNAME }}
                          </td> 
                          <td>
                            {{ data.PRODUCTNAME}} ({{ data.UNIT }})
                          </td>
            
                                               
                        </tr>
                      </tbody>
                      
                    </table>
                  </div>
                </div>
              </b-field>
            </div>
          </div>
          
        </b-tab-item>

        <b-tab-item label="ສະຫຼຸບສິນຄ້າໃນສາງ ປະຈຳວັນ">
          <div class="columns">
            <div class="column" >
              <b-field>
                <div class="columns" style=" display: flex">
                  
                  <div class="column">
                    <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ລາຍການສິນຄ້າ ຄ້າງສາງ ປະຈຳວັນ</div>    
                    <div class="columns">
                      <div class="column" style="padding-right:50px; margin-top: 20px;">
                        <b-button
                          class="btn-group-margin  is-fullwidth"
                          type="is-info"  
                          @click="getStockProductRemain()"
                          >ດຶງສິນຄ້າ ຄ້າງສ້າງ ປະຈຳວັນ
                        </b-button> 
                      </div>
                      <div class="column" style="padding-right:50px; margin-top: 20px;">
                        <b-button
                          class="btn-group-margin  is-fullwidth"
                          type="is-danger"  
                          @click="saveProductRemainToStock()"
                          >ບັນທຶກສິນຄ້າ ຄ້າງສ້າງ ປະຈຳວັນ
                        </b-button> 
                      </div>
                      <div class="column" style="">

                      </div>

                      <div class="column" style="">
                        ວັນທີ
                        <b-field label="">
                          <b-field>
                            <b-datepicker
                              :date-formatter="dateFormatter"
                              v-model="stockProductRemainDate"
                            >  
                            </b-datepicker>
                          </b-field>
                        </b-field>
                      </div> 
                      <div class="column" style=" margin-top: 20px;"  >
                        <b-button
                          class="btn-group-margin  is-fullwidth" 
                          type="is-success"  
                          
                          @click="getStockProductRemainSaved()"
                          >ດືງຂໍ້ມູນ
                        </b-button> 
                      </div>
                    
                    </div>

                    <div class="columns" v-if="isGetStockProductRemain==0" style="margin-top: 30px;">
                      <div style="font-size: 20px;"> ບັນທຶກສິນຄ້າ ຄ້າງສາງ ປະຈຳວັນ</div>
                    </div>
                    <div class="columns" v-if="isGetStockProductRemain==0">  
                     
                       <div class="column">
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="3%">#</th>

                              <th class="has-text-left " width="40%">
                                ສິນຄ້າ
                              </th>
                              <th class="has-text-left " width="10%">
                                ຫົວໜ່ວຍ
                              </th>
                              <th class="has-text-right " width="10%">
                                ຈຳນວນ
                              </th>
                              
                              <th class="has-text-right " width="10%">
                                ລາຄາ
                              </th>
                              <th class="has-text-right " width="15%">
                                ລວມເປັນເງິນ
                              </th>
                          
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in stockProductRemainList"
                              :key="data.PRODUCTID"
                            >

                              <td class="has-text-centered">
                                {{index + 1}}
                              </td>
                              <td class="has-text-left">
                                {{  data.PRODUCTNAME }}
                              </td>   
                              <td class="has-text-left">  
                                {{ data.UNIT}}
                              </td>
                              <td class="has-text-right">
                                {{ data.QUANTITY  | formatNumberLocal_decimal(2)}}
                                <!-- {{ data.STOCKQUANTITY  | formatNumberLocal}} -->
                              </td>
                              
                              <td class="has-text-right">
                                {{ data.UNITPRICE  | formatNumberLocal_decimal(2)}} 
                              </td>  
                              <td class="has-text-right">
                                {{ data.REMAINVALUE | formatNumberLocal_decimal(2)}}  
                              </td>
                 
                                                  
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="5" class="has-text-right">
                                ລວມ
                                {{ stockProductRemainList.length | formatNumberLocal_decimal(2) }}
                                ລາຍການ
                              </th>
                              <th class="has-text-right">
                                {{ 
                                  _.sumBy(stockProductRemainList, (i) => i["REMAINVALUE"] * 1)
                                    | formatNumberLocal_decimal(2)
                                }}
                              </th>
                            </tr>
                          </tfoot>
                          
                        </table>

                       </div>
                    </div>

                    <div class="columns" v-if="isGetStockProductRemain==1" style="margin-top: 30px;">
                      <div style="font-size: 20px;"> ລາຍການ ເຄື່ອງຄ້າງສາງວັນທີ {{ dateFormatter(stockProductRemainDate) }}</div>
                    </div>
                    <div class="columns" v-if="isGetStockProductRemain==1">  
                     
                       <div class="column">
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="3%">#</th>

                              <th class="has-text-left " width="40%">
                                ສິນຄ້າ
                              </th>
                              <th class="has-text-centered " width="10%">
                                ຫົວໜ່ວຍ
                              </th>
                              <th class="has-text-right " width="10%">
                                ຈຳນວນ
                              </th>
                              
                              <th class="has-text-right " width="10%">
                                ລາຄາ
                              </th>
                              <th class="has-text-right " width="15%">
                                ລວມເປັນເງິນ
                              </th>
                          
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in stockProductRemainSavedList"
                              :key="data.PRODUCTID"
                            >

                              <td class="has-text-centered">
                                {{index + 1}}
                              </td>
                              <td class="has-text-left">
                                {{  data.PRODUCTNAME }}
                              </td> 
                              <td class="has-text-centered">
                                {{ data.UNIT}}
                              </td>
                              <td class="has-text-right">
                                {{ data.QUANTITY  | formatNumberLocal}}
                                <!-- {{ data.STOCKQUANTITY  | formatNumberLocal}} -->
                              </td>
                              
                              <td class="has-text-right">
                                {{ data.UNITPRICE  | formatNumberLocal}} 
                              </td>
                              <td class="has-text-right">
                                {{ data.TOTAL | formatNumberLocal}}
                              </td>
                
                                                  
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="5" class="has-text-right">
                                ລວມ
                                {{ stockProductRemainSavedList.length | formatNumberLocal }}
                                ລາຍການ
                              </th>
                              <th class="has-text-right">
                                {{
                                  _.sumBy(stockProductRemainSavedList, (i) => i["TOTAL"] * 1)
                                    | formatNumberLocal
                                }}
                              </th>
                            </tr>
                          </tfoot>
                          
                        </table>

                       </div>
                    </div>
                        
                  </div>
                </div>
              </b-field>
            </div>
          </div>
          
        </b-tab-item>

        <b-tab-item label="Mapping ສິນຄ້າອອກຕະຫຼາດ-ສາງ">
          <div class="columns">
            <div class="column" >
              <b-field>
                <div class="columns" style=" display: flex">
                  
                  <div class="column">
                    <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ສິນຄ້າອອກຕະຫຼາດ-ສາງ</div>    
                    <div class="columns">  
                     
                      <div class="column">
                        <b-field label="ຄົ້ນຫາຊື່ສິນຄ້າ ສາງສິນຄ້າ">
                          <b-input
                            v-model.trim="stockProductName"
                            type="text"
                            @input="getAllStockProductList"
                          >  
                          </b-input>
                        </b-field>
                      </div>
                      <div class="column">
                      </div>
                    </div>
                    
                    <div class="columns">  
                     
                      <div class="column">
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="1%">#</th>

                              <th class="has-text-left " width="67%">
                                ສິນຄ້າ-ສາງສິນຄ້າ
                              </th>
                              <th class="has-text-right " width="32%">  
                                ຈຳນວນສິນຄ້າ<br>
                                ອອກຕະຫຼາດ
                              </th>
                              
                          
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in allStockProductList"  
                              :key="data.PRODUCTID"
                            >

                              <td class="has-text-centered">
                                {{index + 1}}
                              </td>
                              <td class="has-text-left">
                                <a 
                                  :href="stockurl"
                                  @click="selectStockProduct(data.PRODUCTID, data.PRODUCTNAME, data.UNIT)" 
                                >
                                   &nbsp; {{data.PRODUCTID}}-{{  data.PRODUCTNAME }} ({{ data.UNIT }})
                                </a>

                               
                              </td> 
                             
                              <td class="has-text-right">
                                {{ data.OKPRODUCTCOUNT | formatNumberLocal}}
                              </td>
                
                                                  
                            </tr>
                          </tbody>
                          
                        </table>

                      </div>
                      <div class="column" style="margin-top: -85px;">
                        <b-field>
                          <span>ສິນຄ້າທີ່ເລືອກ: <span style="color: red;">{{ selectedStockProductNameForOk }} ({{ selectedStockProductUnitForOk }})</span></span>   
                        </b-field>
                        <b-field style="margin-top: -10px;">
                          <table class="table is-fullwidth is-narrow is-small" style="background-color: #1E88E5; color: white">   
                            <thead>
                              <tr >
                                <th class="has-text-centered " width="3%" style="color: white;">#</th>

                                <th class="has-text-left " width="40%" style="color: white;">
                                  ສິນຄ້າ-ອອກຕະຫຼາດ
                                </th>
                                <th class="has-text-right " width="5%" style="color: white;">
                                  ຫຼັກ?
                                </th>
                                <th class="has-text-right " width="5%" style="color: white;">
                                  ຕົວຄູນ
                                </th>
                                
                                <th class="has-text-right " width="5%" style="color: white;">
                                  ຈັດການ
                                </th>
                            
                                
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(data, index) in okStockProductList"
                                :key="data.OKPRODUCTID"
                              >

                                <td class="has-text-centered">
                                  {{index + 1}}
                                </td>
                                <td class="has-text-left">
                                  {{data.OKPRODUCTID}}-{{  data.PRODUCTNAME }} <span style=" background-color: black; padding: 5px 5px;">{{ data.UNIT }}</span>    
                                </td> 
                                <td class="has-text-right">
                                  <b-field v-if="data.ISMAIN==0" >
                                    <b-button style="background-color: black; color: white;"
                                        class="btn-group-margin"
                                        type="is-warning"    
                                        @click="updateMainMappingMultiply(data,1)"
                                        > ?
                                    </b-button>
                                  </b-field>
                                  <b-field v-else-if="data.ISMAIN==1" style="font-size: 30px;">
                                    &#9989;
                                  </b-field>
                                </td> 
                                <td class="has-text-right">
                                  <b-button 
                                      class="btn-group-margin"
                                      type="is-warning"    
                                      @click="updateMappingMultiply(data)"
                                      >{{ data.MULTIPLY }}  
                                    </b-button>
                                </td> 
                                
                                <td class="has-text-right">
                                  <b-field>
                                    <b-button
                                      class="btn-group-margin" 
                                      type="is-danger"  
                                      @click="cancelMapOkStockProduct(data.OKPRODUCTID)"
                                      >X  
                                    </b-button>
                                  </b-field>
                                    
                                </td>
                  
                                                    
                              </tr>
                            </tbody>
                            
                          </table>
                        </b-field>
                        <b-field grouped style="margin-top: 30px;">
                          <b-field label="ຄົ້ນຫາຊື່ສິນຄ້າ ອອກຕະຫຼາດ">
                            <b-input
                              v-model.trim="okProductName"
                              type="text"
                              @input="searchOkProductKey"
                            >  
                            </b-input>
                          </b-field>
                          <!-- <b-field style="padding-top: 28px;">   
                            <b-button
                              class="btn-group-margin"
                              type="is-info"  
                              @click="searchOkProductKey()"
                              >ຄົ້ນຫາ
                            </b-button>
                          </b-field> -->
                        </b-field>
                          
                       
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="3%">#</th>

                              <th class="has-text-left " width="40%">
                                ສິນຄ້າ-ອອກຕະຫຼາດ
                              </th>
                              
                              <th class="has-text-right " width="15%">
                                ຈັດການ
                              </th>
                          
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in okProductList"
                              :key="data.PRODUCTID"
                            >

                              <td class="has-text-centered">
                                {{index + 1}}
                              </td>
                              <td class="has-text-left">
                                {{data.PRODUCTID}}-{{  data.PRODUCTNAME }} (<span style="color: red;">{{ data.UNIT }}</span>) 
                              </td> 
                              
                              <td class="has-text-right">
                                <b-field v-if="data.OKPRODUCTID == null">       
                                  <b-button 
                                    class="btn-group-margin"   
                                    type="is-success"  
                                    @click="mapOkStockProduct(data.PRODUCTID)"
                                    >Map
                                  </b-button>
                                </b-field>
                                <b-field v-else>
                                  &#9989; ສຳເລັດ
                                </b-field>
                                  
                              </td>
                
                                                  
                            </tr>
                          </tbody>
                          
                        </table>
                      </div>
                    </div>
                        
                  </div>
                </div>
              </b-field>
            </div>
          </div>
          
        </b-tab-item>
        <b-tab-item label="ປະເມີນການຊື້-ຂາຍສິນຄ້າ">
          <b-tabs v-model="activeTabSub2" >
            <b-tab-item label="ຊື້-ຂາຍສິນຄ້າ-ເສຍຫາຍ">   
              <div class="columns">
                  <div class="column" >
                    <b-field>
                      <div class="columns" style=" display: flex">
                        <div class="column">
                          <div style="font-size:18px; font-weight: bold; margin-bottom: 20px"></div>    
                          <div class="columns">
                            <div class="column" style="padding-right:50px;">
                              <b-field grouped>
                                <b-field>
                                  <b-datepicker
                                    :date-formatter="dateFormatter"
                                    v-model="productStockCompareStartdate"
                                  >
                                  </b-datepicker>
                                </b-field>
                              </b-field>
                            </div>
                            <div class="column" style="padding-right:50px;">
                              <b-field grouped>
                                <b-field>
                                  <b-datepicker
                                    :date-formatter="dateFormatter"
                                    v-model="productStockCompareEnddate"
                                  >
                                  </b-datepicker>
                                </b-field>
                              </b-field>
                            </div>

                            <div class="column" style="padding-right:50px;">
                              <b-field>
                                <Multiselect
                                  placeholder="ເລືອກກຸ່ມສິນຄ້າ"
                                  v-model.trim="selectedGroup"
                                  label="NAME"
                                  track-by="ID"
                                  :options="groupList"
                                >
                                </Multiselect>
                              </b-field>
                            </div> 

                            <div class="column" style="padding-right:50px;">
                              <b-field>
                                <Multiselect
                                  placeholder="ເລືອກສິນຄ້າ"
                                  v-model.trim="selectedProduct"
                                  label="NAME"
                                  track-by="ID"
                                  :options="stockProductList"
                                >
                                </Multiselect>
                              </b-field>
                            </div> 

                            <div class="column">
                              <b-field>
                                <b-button
                                  class="btn-group-margin is-fullwidth"
                                  type="is-info"
                                  @click="getProductStockCompare()"
                                  >ເບິ່ງຂໍ້ມູນ
                                </b-button>
                              </b-field>
                            </div>
                          
                          </div>
                          <table class="table is-fullwidth is-narrow is-small">
                            <thead>
                              <tr>
                                <th class="has-text-centered " width="2%">#</th>
                                <th class="has-text-left " width="30%">
                                  ສິນຄ້າ
                                </th>
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນເງິນຊື້ເຂົ້າສາງ
                                </th> 
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນເງິນເສຍຫາຍ
                                </th>
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນເງິນຂາຍອອກ
                                </th> 
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນເງິນຍັງເຫຼືອ
                                </th> 
                                
                                
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(data, index) in productStockCompareList"
                                :key="data.PRODUCTID"   
                              >
                                <td class="has-text-centered">{{ index + 1 }}
                                </td>

                                <td class="has-text-left">    
                                  {{data.PRODUCTNAME}}   
                                </td>
                                <td class="has-text-right">
                                  {{ data.TOTALBUY | formatNumberLocal_decimal(2) }}    
                                </td>
                                <td class="has-text-right">
                                  {{ data.TOTALBROKEN | formatNumberLocal_decimal(2)  }}
                                </td> 
                                
                                <td class="has-text-right">
                                  {{ data.TOTALSELL | formatNumberLocal_decimal(2)  }}
                                </td>
                    
                                <td class="has-text-right">
                                  {{ (data.TOTALSELL - data.TOTALBUY - data.TOTALBROKEN) | formatNumberLocal_decimal(2)  }}   
                                </td> 
                                
                                
                                                              
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <th colspan="2" class="has-text-centered">
                                  ລວມ
                                  {{ productStockCompareList.length | formatNumberLocal }}  
                                  ລາຍການ
                                </th>  
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(productStockCompareList, (i) => i["TOTALBUY"] * 1) | formatNumberLocal_decimal(2)
                                  }}
                                </th>
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(productStockCompareList, (i) => i["TOTALBROKEN"] * 1) | formatNumberLocal_decimal(2)
                                  }}   
                                </th>
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(productStockCompareList, (i) => i["TOTALSELL"] * 1) | formatNumberLocal_decimal(2)
                                  }}
                                </th>   
                                <th class="has-text-right">
                                  {{ 
                                    _.sumBy(productStockCompareList, (i) => i["TOTALSELL"]- i["TOTALBUY"] - i["TOTALBROKEN"] ) | formatNumberLocal_decimal(2)
                                  }}
                                </th>  
                                

                              </tr>
                            </tfoot>
                            
                          </table>
                        </div>
                      </div>
                        
                    </b-field>
                  </div>
                </div>
            </b-tab-item>

            <b-tab-item label="ປະເມີນສິນຄ້າໃນສາງ ກັບຍອດຊື້">   
              <div class="columns">
                  <div class="column" >
                    <b-field>
                      <div class="columns" style=" display: flex">
                        <div class="column">
                          <div style="font-size:18px; font-weight: bold; margin-bottom: 20px"></div>    
                          <div class="columns">
                            <div class="column" style="padding-right:50px;">
                              <b-field grouped>
                                <b-field label="ວັນທີຂາຍສິນຄ້າ">
                                  <b-datepicker
                                    :date-formatter="dateFormatter"
                                    v-model="okstockeastimatedate"
                                  >
                                  </b-datepicker>
                                </b-field>
                              </b-field>
                            </div>

                            <div class="column">
                              <b-field style="margin-top:23px">
                                <b-button
                                  class="btn-group-margin is-fullwidth"
                                  type="is-info"
                                  @click="getOkStockEstimate()"  
                                  >ເບິ່ງຂໍ້ມູນ
                                </b-button>
                              </b-field>
                            </div>
                          
                          </div>
                          <div class="columns">
                            <div class="column" style="text-align: right;">
                              <b-field label="ຍອດຂາຍ OK ທັງໝົດ" style="font-weight: bold;">
                                {{ alloktotalsell | formatNumberLocal_decimal(2) }}
                              </b-field>
                              
                            </div>
                            <div class="column" style="text-align: right;">
                              <b-field label="ຍອດຂາຍລາຍການສິນຄ້າໃນ Stock">
                                {{
                                    _.sumBy(okstockeastimateList, (i) => i["SHOULDBE_TOTALSELL"] * 1) | formatNumberLocal_decimal(2)
                                }}
                              </b-field>
                              
                            </div>

                            <div class="column" style="text-align: right;">
                              <b-field label="ຍອດຂາຍສິນຄ້າ Stock ຈຳນວນຕົວຈິງ">
                                {{
                                  _.sumBy(okstockeastimateList, (i) => i["EASTIMATE_TOTALSELL"] * 1) | formatNumberLocal_decimal(2)
                                }}
                              </b-field>
                              
                            </div>

                            <div class="column" style="text-align: right;">
                              <b-field label="ຄ່າເສຍໂອກາດ" style="color: red">
                                {{
                                  _.sumBy(okstockeastimateList, (i) => i["NOTENOUGH_TOTALSELL"] * 1) | formatNumberLocal_decimal(2)
                                }}
                              </b-field>
                              
                            </div>                            
                          </div>        
                              
                          <table class="table is-fullwidth is-narrow is-small">
                            <thead>
                              <tr>
                                <th class="has-text-centered " width="2%">#</th>
                                <th class="has-text-left " width="30%">
                                  ສິນຄ້າ
                                </th>   
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນ<br>OK
                                </th> 
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນ<br>Stock
                                </th>
                                <th class="has-text-right " width="10%">
                                  ສ່ວນຕ່າງ
                                </th>
                                <th class="has-text-right " width="10%">
                                  ລາຄາຂາຍ<br>ອອກ Stock
                                </th> 
                                <th class="has-text-right " width="15%">
                                  ຈຳນວນເງິນຂາຍ<br>
                                  ທີ່ລູກຄ້າຕ້ອງການ
                                </th> 
                                <th class="has-text-right " width="15%">
                                  ຈຳນວນເງິນຂາຍ<br>
                                  ທີ່ມີໃນ Stock
                                </th> 
                                <th class="has-text-right " width="20%">
                                  ຈຳນວນເງິນຂາຍ<br>
                                  ທີ່ເສຍໂອກາດ
                                </th> 
                                
                                
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(data, index) in okstockeastimateList"
                                :key="data.PRODUCTID"   
                              >
                                <td class="has-text-centered">{{ index + 1 }}
                                </td>

                                <td class="has-text-left">
                                  <span style="color: red" v-if="data.STOCKQUANTITY < 1">
                                    {{data.PRODUCTNAME}} 
                                  </span>    
                                  <span v-else>
                                    {{data.PRODUCTNAME}} 
                                  </span>
                                  
                                </td>
                                <td class="has-text-right">
                                  {{ data.OKQUANTITY | formatNumberLocal_decimal(2) }}    
                                </td>
                                <td class="has-text-right">
                                  {{ data.STOCKQUANTITY | formatNumberLocal_decimal(2)  }}
                                </td> 

                                <td class="has-text-right" >
                                  <span style="color:red" v-if="data.STOCKQUANTITY > data.OKQUANTITY">
                                    {{ data.STOCKQUANTITY-data.OKQUANTITY | formatNumberLocal_decimal(2)  }}
                                  </span>
                                  <span v-else>
                                    {{ data.STOCKQUANTITY-data.OKQUANTITY | formatNumberLocal_decimal(2)  }}
                                  </span>
                                  
                                </td> 
                                
                                <td class="has-text-right">
                                  {{ data.UNITPRICE | formatNumberLocal_decimal(2)  }}
                                </td>
                                <td class="has-text-right">
                                  {{ data.SHOULDBE_TOTALSELL | formatNumberLocal_decimal(2)  }}
                                </td>

                                <td class="has-text-right">
                                  {{ data.EASTIMATE_TOTALSELL | formatNumberLocal_decimal(2)  }}
                                </td>
                    
                                <td class="has-text-right" style="color:red">
                                  {{ data.NOTENOUGH_TOTALSELL | formatNumberLocal_decimal(2)  }}   
                                </td> 
                                             
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <th colspan="2" class="has-text-centered">
                                  ລວມ
                                  {{ okstockeastimateList.length | formatNumberLocal }}  
                                  ລາຍການ
                                </th>  
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(okstockeastimateList, (i) => i["OKQUANTITY"] * 1) | formatNumberLocal_decimal(2)
                                  }}
                                </th>
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(okstockeastimateList, (i) => i["STOCKQUANTITY"] * 1) | formatNumberLocal_decimal(2)
                                  }}   
                                </th>
                                <th class="has-text-centered">
                                 
                                </th>  
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(okstockeastimateList, (i) => i["SHOULDBE_TOTALSELL"] * 1) | formatNumberLocal_decimal(2)
                                  }}
                                </th>   
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(okstockeastimateList, (i) => i["EASTIMATE_TOTALSELL"] * 1) | formatNumberLocal_decimal(2)
                                  }}
                                </th> 
                                <th class="has-text-right">
                                  <span v-if="parseFloat(notEnoughTotalSellSum) < 0" style="color:red">
                                    {{ notEnoughTotalSellSum | formatNumberLocal_decimal(2) }}
                                  </span>
                                  <span v-else>
                                    {{ notEnoughTotalSellSum | formatNumberLocal_decimal(2) }}
                                  </span>
                                  
                                </th> 
                                

                              </tr>
                            </tfoot>
                            
                          </table>
                        </div>
                      </div>
                        
                    </b-field>
                  </div>
                </div>
            </b-tab-item>

            <b-tab-item label="ການຊື້-ຂາຍສິນຄ້າ ວັນທີຊື້ເຂົ້າ-ຂາຍອອກ">   
              <div class="columns">
                  <div class="column" >
                    <b-field>
                      <div class="columns" style=" display: flex">
                        <div class="column">
                          <div style="font-size:18px; font-weight: bold; margin-bottom: 20px"></div>    
                          <div class="columns">
                            <div class="column" style="padding-right:50px;">
                              <b-field grouped>
                                <b-field>
                                  <b-datepicker
                                    :date-formatter="dateFormatter"
                                    v-model="stockbyandsellstartdate"
                                  >
                                  </b-datepicker>
                                </b-field>
                              </b-field>
                            </div>
                            <div class="column" style="padding-right:50px;">
                              <b-field grouped>
                                <b-field>
                                  <b-datepicker
                                    :date-formatter="dateFormatter"
                                    v-model="stockbyandsellenddate"
                                  >
                                  </b-datepicker>
                                </b-field>
                              </b-field>
                            </div>

                            <div class="column" style="padding-right:50px;">
                              <b-field>
                                <Multiselect
                                  placeholder="ເລືອກກຸ່ມສິນຄ້າ"
                                  v-model.trim="selectedGroup"
                                  label="NAME"
                                  track-by="ID"
                                  :options="groupList"
                                >
                                </Multiselect>
                              </b-field>
                            </div> 

                            <div class="column" style="padding-right:50px;">
                              <b-field>
                                <Multiselect
                                  placeholder="ເລືອກສິນຄ້າ"
                                  v-model.trim="selectedProduct"
                                  label="NAME"
                                  track-by="ID"
                                  :options="stockProductList"
                                >
                                </Multiselect>
                              </b-field>
                            </div> 

                            <div class="column">
                              <b-field>
                                <b-button
                                  class="btn-group-margin is-fullwidth"
                                  type="is-info"
                                  @click="getStockbyuandsellresult()"
                                  >ເບິ່ງຂໍ້ມູນ
                                </b-button>
                              </b-field>
                            </div>
                          
                          </div>
                          <table class="table is-fullwidth is-narrow is-small">
                            <thead>
                              <tr>
                                <th class="has-text-centered " width="2%">#</th>

                          
                                <th class="has-text-left " width="20%">
                                  ສິນຄ້າ
                                </th>
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນເງິນ<br>ເຂົ້າສາງ
                                </th> 
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນ<br>ເຂົ້າສາງ
                                </th>
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນ<br>ເສຍຫາຍ
                                </th> 
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນ<br>ຂາຍອອກ
                                </th> 
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນ<br>ຍັງເຫຼືອ
                                </th>  
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນເງິນ<br>ຍັງເຫຼືອ
                                </th> 
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນເງິນ<br>ເສຍຫາຍ
                                </th>
                                <th class="has-text-right " width="10%">
                                  ຈຳນວນເງິນ<br>ຂາຍອອກ
                                </th>
                                <th class="has-text-right " width="10%">
                                  ກຳໄລ<br>/ຂາດທືນ
                                </th>
                                
                                
                                
                                
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(data, index) in stockbuyandsell"
                                :key="data.ID"   
                              >
                                <td class="has-text-centered">{{ index + 1 }}
                                </td>

                                <td class="has-text-left">    
                                  {{data.PRODUCTNAME}}   
                                </td>
                                <td class="has-text-right">
                                  {{ data.STOCKINTOTALPRICE | formatNumberLocal }}    
                                </td>
                                <td class="has-text-right">
                                  {{ data.STOCKIN | formatNumberLocal }}
                                </td> 
                                
                                <td class="has-text-right">
                                  {{ data.BROKEN | formatNumberLocal }}
                                </td>
                                
                                <td class="has-text-right">
                                  {{ data.SELL | formatNumberLocal }}
                                </td>
                    
                                <td class="has-text-right">
                                  {{ data.STOCKIN - data.BROKEN - data.SELL | formatNumberLocal }}
                                </td> 
                                <td class="has-text-right">
                                
                                </td> 
                                <td class="has-text-right">
                                  {{ data.BROKENTOTAL | formatNumberLocal }}
                                </td>  
                                <td class="has-text-right">
                                  {{ data.SELLTOTAL | formatNumberLocal }}
                                </td>  
                                <td class="has-text-right">
                                  {{ data.SELLTOTAL-data.STOCKINTOTALPRICE | formatNumberLocal }}
                                </td>  
                                
                                                              
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <th colspan="2" class="has-text-centered">
                                  ລວມ
                                  {{ stockbuyandsell.length | formatNumberLocal }}  
                                  ລາຍການ
                                </th>
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(stockbuyandsell, (i) => i["STOCKINTOTALPRICE"] * 1)
                                      | formatNumberLocal
                                  }}
                                </th>
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(stockbuyandsell, (i) => i["STOCKIN"] * 1)
                                      | formatNumberLocal
                                  }}
                                </th>
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(stockbuyandsell, (i) => i["BROKEN"] * 1)
                                      | formatNumberLocal
                                  }}
                                </th>   
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(stockbuyandsell, (i) => i["SELL"] * 1)
                                      | formatNumberLocal
                                  }}
                                </th>  
                                <th class="has-text-right">
                                  {{ 
                                    _.sumBy(stockbuyandsell, (i) => i["STOCKIN"]- i["BROKEN"]-i["SELL"] )
                                      | formatNumberLocal
                                  }}
                                </th>  
                                <th class="has-text-right">
                                  ---
                                </th>  
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(stockbuyandsell, (i) => i["BROKENTOTAL"] * 1)
                                      | formatNumberLocal
                                  }}
                                </th>
                                <th class="has-text-right">
                                  {{
                                    _.sumBy(stockbuyandsell, (i) => i["STOCKINTOTALPRICE"] * 1)
                                      | formatNumberLocal
                                  }}
                                </th>   
                                <th class="has-text-right">
                                  {{ 
                                    _.sumBy(stockbuyandsell, (i) => i["SELLTOTAL"]-i["STOCKINTOTALPRICE"])   
                                      | formatNumberLocal
                                  }}
                                </th> 

                              </tr>
                            </tfoot>
                            
                          </table>
                        </div>
                      </div>
                        
                    </b-field>
                  </div>
                </div>
            </b-tab-item>
            <b-tab-item label="ການຊື້-ຂາຍສິນຄ້າ ສະເພາະສິນຄ້າທີ່ຊື້ເຂົ້າຕາມວັນທີ">  
              <b-tabs v-model="activeTabSub3" >
                <b-tab-item label="ການຊື້-ຂາຍສິນຄ້າ ວັນທີຊື້ເຂົ້າ-ຂາຍອອກ">   
                  <div class="columns">
                      <div class="column" >
                        <b-field>
                          <div class="columns" style=" display: flex">
                            <div class="column">
                              <div style="font-size:18px; font-weight: bold; margin-bottom: 20px"></div>    
                              <div class="columns">
                                <div class="column" style="padding-right:50px;">
                                  <b-field grouped>
                                    <b-field>
                                      <b-datepicker
                                        :date-formatter="dateFormatter"
                                        v-model="stockbyandsellstartdate2"
                                      >
                                      </b-datepicker>
                                    </b-field>
                                  </b-field>
                                </div>
                                <div class="column" style="padding-right:50px;">
                                  <b-field grouped>
                                    <b-field>
                                      <b-datepicker
                                        :date-formatter="dateFormatter"
                                        v-model="stockbyandsellenddate2"
                                      >
                                      </b-datepicker>
                                    </b-field>
                                  </b-field>
                                </div>

                                <div class="column" style="padding-right:50px;">
                                  <b-field>
                                    <Multiselect
                                      placeholder="ເລືອກກຸ່ມສິນຄ້າ"
                                      v-model.trim="selectedGroup2"
                                      label="NAME"
                                      track-by="ID"
                                      :options="groupList"
                                    >
                                    </Multiselect>
                                  </b-field>
                                </div> 

                                <div class="column" style="padding-right:50px;">
                                  <b-field>
                                    <Multiselect
                                      placeholder="ເລືອກສິນຄ້າ"
                                      v-model.trim="selectedProduct2"
                                      label="NAME"
                                      track-by="ID"
                                      :options="stockProductList"
                                    >
                                    </Multiselect>
                                  </b-field>
                                </div> 

                                <div class="column">
                                  <b-field>
                                    <b-button
                                      class="btn-group-margin is-fullwidth"
                                      type="is-info"
                                      @click="getStockbyuandsellresultonlybystockin()"
                                      ><span style=" font-family: Phetsarath OT !important ;">ເບິ່ງຂໍ້ມູນ</span>
                                    </b-button>
                                  </b-field>
                                </div>
                              
                              </div>
                              <table class="table is-fullwidth is-narrow is-small">
                                <thead>
                                  <tr>
                                    <th class="has-text-centered " width="2%">#</th>

                              
                                    <th class="has-text-left " width="20%">
                                      ສິນຄ້າ
                                    </th>
                                    <th class="has-text-right " width="10%">
                                      ຈຳນວນເງິນ<br>ເຂົ້າສາງ
                                    </th> 
                                    <th class="has-text-right " width="10%">
                                      ຈຳນວນ<br>ເຂົ້າສາງ
                                    </th>
                                    <th class="has-text-right " width="10%">
                                      ຈຳນວນ<br>ເສຍຫາຍ
                                    </th> 
                                    <th class="has-text-right " width="10%">
                                      ຈຳນວນ<br>ຂາຍອອກ
                                    </th> 
                                    <th class="has-text-right " width="10%">
                                      ຈຳນວນ<br>ຍັງເຫຼືອ
                                    </th>  
                                    <th class="has-text-right " width="10%">
                                      ຈຳນວນເງິນ<br>ຍັງເຫຼືອ
                                    </th> 
                                    <th class="has-text-right " width="10%">
                                      ຈຳນວນເງິນ<br>ເສຍຫາຍ
                                    </th>
                                    <th class="has-text-right " width="10%">
                                      ຈຳນວນເງິນ<br>ຂາຍອອກ
                                    </th>
                                    <th class="has-text-right " width="10%">
                                      ກຳໄລ<br>/ຂາດທືນ
                                    </th>
                                    
                                    
                                    
                                    
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(data, index) in stockbuyandsell2"
                                    :key="data.ID"   
                                  >
                                    <td class="has-text-centered">{{ index + 1 }}
                                    </td>

                                    <td class="has-text-left">    
                                      {{data.PRODUCTNAME}}   
                                    </td>
                                    <td class="has-text-right">
                                      {{ data.STOCKINTOTALPRICE | formatNumberLocal }}    
                                    </td>
                                    <td class="has-text-right">
                                      {{ data.STOCKIN | formatNumberLocal }}
                                    </td> 
                                    
                                    <td class="has-text-right">
                                      {{ data.BROKEN | formatNumberLocal }}
                                    </td>
                                    
                                    <td class="has-text-right">
                                      {{ data.SELL | formatNumberLocal }}
                                    </td>
                        
                                    <td class="has-text-right">
                                      {{ data.STOCKIN - data.BROKEN - data.SELL | formatNumberLocal }}
                                    </td> 
                                    <td class="has-text-right">
                                    
                                    </td> 
                                    <td class="has-text-right">
                                      {{ data.TOTALBROKEN | formatNumberLocal }}   
                                    </td>  
                                    <td class="has-text-right">
                                      {{ data.TOTALSELL | formatNumberLocal }}
                                    </td>  
                                    <td class="has-text-right">
                                      {{ data.TOTALSELL-data.STOCKINTOTALPRICE | formatNumberLocal }} <br>

                                      <b-button
                                        style="float: right;"
                                        class="btn-group-margin"
                                        type="is-success" 
                                        size="is-small" 
                                        @click="getStockbyuandsellresultonlybystockinDetail(data.PRODUCTID, data.PRODUCTNAME)" 
                                        > <span style=" font-family: Phetsarath OT !important ;">ລາຍລະອຽດ</span>
                                      </b-button> 

                                    </td>   
                                    
                                                                  
                                  </tr>
                                </tbody>

                                <tfoot>
                                  <tr>
                                    <th colspan="2" class="has-text-centered">
                                      ລວມ
                                      {{ stockbuyandsell2.length | formatNumberLocal }}  
                                      ລາຍການ
                                    </th>
                                    <th class="has-text-right">
                                      {{
                                        _.sumBy(stockbuyandsell2, (i) => i["STOCKINTOTALPRICE"] * 1)
                                          | formatNumberLocal
                                      }}
                                    </th>
                                    <th class="has-text-right">
                                      {{
                                        _.sumBy(stockbuyandsell2, (i) => i["STOCKIN"] * 1)
                                          | formatNumberLocal
                                      }}
                                    </th>
                                    <th class="has-text-right">
                                      {{
                                        _.sumBy(stockbuyandsell2, (i) => i["BROKEN"] * 1)
                                          | formatNumberLocal
                                      }}
                                    </th>   
                                    <th class="has-text-right">
                                      {{
                                        _.sumBy(stockbuyandsell2, (i) => i["SELL"] * 1)
                                          | formatNumberLocal
                                      }}
                                    </th>  
                                    <th class="has-text-right">
                                      {{ 
                                        _.sumBy(stockbuyandsell2, (i) => i["STOCKIN"]- i["BROKEN"]-i["SELL"] )
                                          | formatNumberLocal
                                      }}
                                    </th>  
                                    <th class="has-text-right">
                                      ---
                                    </th>  
                                    <th class="has-text-right">
                                      {{
                                        _.sumBy(stockbuyandsell2, (i) => i["TOTALBROKEN"] * 1)
                                          | formatNumberLocal
                                      }}
                                    </th>
                                    <th class="has-text-right">
                                      {{
                                        _.sumBy(stockbuyandsell2, (i) => i["TOTALSELL"] * 1)
                                          | formatNumberLocal
                                      }}
                                    </th>   
                                    <th class="has-text-right">
                                      {{ 
                                        _.sumBy(stockbuyandsell2, (i) => i["TOTALSELL"]-i["STOCKINTOTALPRICE"])  
                                          | formatNumberLocal
                                      }}
                                    </th> 

                                  </tr>
                                </tfoot>
                                
                              </table>
                            </div>
                          </div>
                            
                        </b-field>
                      </div>
                    </div>
                </b-tab-item>
                <b-tab-item label="ລາຍລະອຽດ">
                  <div class="columns" style=" display: flex">
                    <div class="column">
                      <b-field grouped>
                        <b-field >
                          ສິນຄ້າ: <span style="font-weight: bold; margin-right: 20px;"> {{ stockbuyandsellProductName }}  </span>    
                        </b-field>
                        <b-field >
                          ຈາກວັນທີ: <span style="font-weight: bold; ">{{ dateFormatter(stockbyandsellstartdate2) }}</span> 
                        </b-field>
                        <b-field >
                          ເຖິງ: <span style="font-weight: bold;">{{ dateFormatter(stockbyandsellenddate2) }}</span>   
                        </b-field>
                      </b-field>
                        
                    </div>
                  </div>  
                  <div class="columns" style=" display: flex">
                    <div class="column">
                      <table class="table is-fullwidth is-narrow is-small">
                        <thead>
                          <tr>
                            <th class="has-text-centered " width="2%">#</th>
                            <th class="has-text-left " width="5%">
                              ວັນທີ/<br>
                              ເລກ Lot
                            </th>
                      
                            <th class="has-text-right " width="10%">
                              ຈຳນວນເງິນ<br>ເຂົ້າສາງ
                            </th> 
                            <th class="has-text-right " width="10%">
                              ຈຳນວນ<br>ເຂົ້າສາງ
                            </th>
                            <th class="has-text-right " width="10%">
                              ຈຳນວນ<br>ເສຍຫາຍ
                            </th> 
                            <th class="has-text-right " width="10%">
                              ຈຳນວນ<br>ຂາຍອອກ
                            </th> 
                            <th class="has-text-right " width="10%">
                              ຈຳນວນ<br>ຍັງເຫຼືອ
                            </th>  
                            <th class="has-text-right " width="10%">
                              ຈຳນວນເງິນ<br>ຍັງເຫຼືອ
                            </th> 
                            <th class="has-text-right " width="10%">
                              ຈຳນວນເງິນ<br>ເສຍຫາຍ
                            </th>
                            <th class="has-text-right " width="10%">
                              ຈຳນວນເງິນ<br>ຂາຍອອກ
                            </th>
                            <th class="has-text-right " width="10%">
                              ກຳໄລ<br>/ຂາດທືນ
                            </th>
                            
                            
                            
                            
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(data, index) in stockbuyandselldetail"
                            :key="data.ID"   
                          >
                            <td class="has-text-centered">{{ index + 1 }}
                            </td>

                            <td class="has-text-left">   
                              {{data.ID}}   <br> 
                              {{data.TXDATE}}   
                            </td>
                            <td class="has-text-right">
                              {{ data.STOCKTOTAL | formatNumberLocal }}    
                            </td>
                            <td class="has-text-right">
                              {{ data.STOCKIN | formatNumberLocal }}
                            </td> 
                            
                            <td class="has-text-right">
                              {{ data.BROKEN | formatNumberLocal }}
                            </td>
                            
                            <td class="has-text-right">
                              {{ data.SELL | formatNumberLocal }}
                            </td>
                
                            <td class="has-text-right">
                              {{ data.STOCKIN - data.BROKEN - data.SELL | formatNumberLocal }}
                            </td> 
                            <td class="has-text-right">
                            
                            </td> 
                            <td class="has-text-right">
                              {{ data.TOTALBROKEN | formatNumberLocal }}   
                            </td>  
                            <td class="has-text-right">
                              {{ data.TOTALSELL | formatNumberLocal }}
                            </td>  
                            <td class="has-text-right">
                              {{ data.TOTALSELL-data.STOCKTOTAL | formatNumberLocal }} <br>    
                            </td>   
                          </tr>
                        </tbody>

                        <tfoot>
                          <tr>
                            <th colspan="2" class="has-text-centered">
                              ລວມ
                              {{ stockbuyandselldetail.length | formatNumberLocal }}  
                              ລາຍການ
                            </th>
                            <th class="has-text-right">
                              {{
                                _.sumBy(stockbuyandselldetail, (i) => i["STOCKTOTAL"] * 1)
                                  | formatNumberLocal
                              }}
                            </th>
                            <th class="has-text-right">
                              {{
                                _.sumBy(stockbuyandselldetail, (i) => i["STOCKIN"] * 1)
                                  | formatNumberLocal
                              }}
                            </th>
                            <th class="has-text-right">
                              {{
                                _.sumBy(stockbuyandselldetail, (i) => i["BROKEN"] * 1)
                                  | formatNumberLocal
                              }}
                            </th>   
                            <th class="has-text-right">
                              {{
                                _.sumBy(stockbuyandselldetail, (i) => i["SELL"] * 1)
                                  | formatNumberLocal
                              }}
                            </th>  
                            <th class="has-text-right">
                              <span
                                v-if="_.sumBy(stockbuyandselldetail, (i) => parseFloat(i.STOCKIN || 0) - parseFloat(i.BROKEN || 0) - parseFloat(i.SELL || 0)) < 0"
                                style="color: red;"
                              >
                                {{
                                  _.sumBy(stockbuyandselldetail, (i) => parseFloat(i.STOCKIN || 0) - parseFloat(i.BROKEN || 0) - parseFloat(i.SELL || 0))
                                    | formatNumberLocal
                                }}
                              </span>
                              
                            </th>  
                            <th class="has-text-right">
                              ---
                            </th>  
                            <th class="has-text-right">
                              {{
                                _.sumBy(stockbuyandselldetail, (i) => i["TOTALBROKEN"] * 1)
                                  | formatNumberLocal
                              }}
                            </th>
                            <th class="has-text-right">
                              {{
                                _.sumBy(stockbuyandselldetail, (i) => i["TOTALSELL"] * 1)
                                  | formatNumberLocal
                              }}
                            </th>   
                            <th class="has-text-right">
                              {{ 
                                _.sumBy(stockbuyandselldetail, (i) => i["TOTALSELL"]-i["STOCKTOTAL"])
                                  | formatNumberLocal
                              }}
                            </th> 

                          </tr>
                        </tfoot>
                        
                      </table>
                    </div>
                  </div>
                </b-tab-item>
              </b-tabs>
                    
            </b-tab-item>

            <b-tab-item label="ສົມທຽບການຊື້ຂອງຕະຫຼາດ ແລະ ສາງ">  
              <div class="columns">
                <div class="column" style="padding-right:50px;">
                  <b-field grouped>
                    <b-field>
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="comparestartdate"
                      >
                      </b-datepicker>
                    </b-field>
                  </b-field>
                </div>
                <div class="column" style="padding-right:50px;">
                  <b-field grouped>
                    <b-field>
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="compareenddate"   
                      >
                      </b-datepicker>
                    </b-field>
                  </b-field>
                </div>

                <div class="column">
                  <b-field>
                    <b-button
                      class="btn-group-margin is-fullwidth"
                      type="is-info"
                      @click="getCompareMarketandStock()"
                      >ເບິ່ງຂໍ້ມູນ
                    </b-button>
                  </b-field>
                </div>
              
              </div>
              <div class="columns" style=" display: flex">
                <div class="column">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="2%">#</th>
                        <th class="has-text-left " width="10%">
                          ວັນທີ
                        </th>
                  
                        <th class="has-text-right " width="10%">
                         ຈຳນວນສິນຄ້າ<br>ຕະຫຼາດ
                        </th> 
                        <th class="has-text-right " width="15%">
                          ຈຳນວນເງິນ<br>ຕະຫຼາດ
                        </th>
                        <th class="has-text-right " width="10%">
                         ຈຳນວນສິນຄ້າ<br>ສາງ
                        </th> 
                        <th class="has-text-right " width="15%">
                          ຈຳນວນເງິນ<br>ສາງ
                        </th>
                        <th class="has-text-right " width="10%">
                          ສ່ວນຕ່າງ<br>ຈຳນວນສິນຄ້າ
                        </th>
                        <th class="has-text-right " width="15%">
                          ສ່ວນຕ່າງ<br>ຈຳນວນເງິນ
                        </th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in compareMarketandStockList"
                        :key="data.REDATE"   
                      >
                        <td class="has-text-centered">{{ index + 1 }}
                        </td>

                        <td class="has-text-left">   
                          {{data.REDATE}}   
                        </td>
                        <td class="has-text-right">
                          {{ data.COUNTPRODUCT_MARKET | formatNumberLocal }}    
                        </td>
                        <td class="has-text-right">
                          {{ data.TOTALPRICE_MARKET | formatNumberLocal }}
                        </td> 
                        
                        <td class="has-text-right">
                          {{ data.COUNTPRODUCT_STOCK | formatNumberLocal }}
                        </td>
                        
                        <td class="has-text-right">
                          {{ data.TOTALPRICE_STOCK | formatNumberLocal }}
                        </td>
            
                        <td class="has-text-right">
                          {{ data.COUNTPRODUCT_STOCK - data.COUNTPRODUCT_MARKET | formatNumberLocal }}
                        </td> 
                        <td class="has-text-right">
                          {{ data.TOTALPRICE_STOCK - data.TOTALPRICE_MARKET | formatNumberLocal }}
                        </td> 
                      </tr>
                    </tbody>

                    <tfoot>
                      <tr>
                        <th colspan="2" class="has-text-centered">
                          ລວມ
                          {{ compareMarketandStockList.length | formatNumberLocal }}  
                          ລາຍການ
                        </th>
                        <th class="has-text-right">
                          {{
                            _.sumBy(compareMarketandStockList, (i) => i["COUNTPRODUCT_MARKET"] * 1)
                              | formatNumberLocal
                          }}
                        </th>
                        <th class="has-text-right">
                          {{
                            _.sumBy(compareMarketandStockList, (i) => i["TOTALPRICE_MARKET"] * 1)
                              | formatNumberLocal
                          }}
                        </th>
                        <th class="has-text-right">
                          {{
                            _.sumBy(compareMarketandStockList, (i) => i["COUNTPRODUCT_STOCK"] * 1)
                              | formatNumberLocal
                          }}
                        </th>   
                        <th class="has-text-right">
                          {{
                            _.sumBy(compareMarketandStockList, (i) => i["TOTALPRICE_STOCK"] * 1)
                              | formatNumberLocal
                          }}
                        </th> 
                        <th class="has-text-right">
                          {{
                            _.sumBy(compareMarketandStockList, (i) => (i["COUNTPRODUCT_STOCK"]-i["COUNTPRODUCT_MARKET"]) * 1)
                              | formatNumberLocal
                          }}
                        </th> 
                        <th class="has-text-right">
                          {{
                            _.sumBy(compareMarketandStockList, (i) =>  (i["TOTALPRICE_STOCK"]-i["TOTALPRICE_MARKET"]) * 1)
                              | formatNumberLocal
                          }}
                        </th>  
                        

                      </tr>
                    </tfoot>
                    
                  </table>
                </div>
              </div>
                    
            </b-tab-item>

          </b-tabs>

                
            
        </b-tab-item>
      </b-tabs>
    </div>
    <div class="contain print-only page-break">
      <div class="contain">
      
      </div>
    </div>
    <div v-if="isUpdateMappingMultiply" class="loading-modal">
      <div class="modal-content">
        <p class="modal-title">ຟອມແກ້ໄຂຕົວຄູນ <br></p>
        <b-field>
          <span style="color:red; font-size: 20px; text-align: left;">{{ selectedMappingMultiplyProductname }}</span>
        </b-field>
        <b-field style="padding-left: 150px;">   
          <b-input
              v-model.trim="selectedMultiply" 
              type="number"
              min="1"
              pattern="[0-9]+"
            >
          </b-input>
        </b-field>
        <b-button
          style="float: right;"
          class="btn-group-margin"
          type="is-success"  
          @click="doUpdateMappingMultiply()" 
          > <span style=" font-family: Phetsarath OT !important ;">ບັນທຶກ</span>
        </b-button> 
          
      </div>  
        
    </div>
    <div class="contain print-only page-break">
      <div class="contain" v-if="printType==1">
        <div class="columns" style="padding: 0 0 0 0; margin: 0 0 0 0 ; page-break-inside: avoid;" >    
          <div class="column" style="padding: 0 0 0 0; margin: 0 0 0 0 ;">
            <div style="padding: 0 0 0 0; margin: 0 0 0 0 ;">
              <div class="columns">   
                <div class="column">   
                  <img
                    class="image-area"
                    style="width: 100px;"
                    :src="getImgUrl('logo/agrilaologo.png')"    
                    alt="Placeholder image"
                  /> 
                </div>   
                
              </div>    
            </div>  
            <div  style="padding: 0 0 0 0; margin: -20px 0 0 0 ;">  
              <div class="columns" style="padding: 0 0 0 0; margin: 0 0 0 0 ;"> 
                <div class="column" style="padding: 0 0 0 0; margin: 0 0 0 0 ;">
                  <div style="font-size: 12px;">
                    Agrilao Innovation Ordinary Partnertship
                  </div>
                  <div style="font-size: 12px;">
                    Address: Dongdok-Sikuert Road,
                  </div>
                  <div style="font-size: 12px; padding-left: 50px;">
                    Sikhottabong Distirct, Vientiane Capital, Laos
                  </div>
                  <div style="font-size: 12px;">
                    Contact No: +85620 55333483, +85620 28040508
                  </div>
                  <div style="font-size: 12px;">
                    Email: argilao.lpdr@gmail.com
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns" >  
          <div class="column">

            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold;">ໃບຮຽກເກັບເງິນ</div> 
              <div style="font-size: 18px;">ລາຍການທີ່ ສາງສິນຄ້າ ຂາຍສິນຄ້າໃຫ້ 
                <span v-if="selectedSectionID !=2">ອອກຕະຫຼາດອອນລາຍ</span> 
                <span v-else>Stock POS</span>    
                
                ປະຈຳວັນທີ: <span style="font-weight: bold;">{{ dateFormatter(productStockOutTxdateByProduct) }}</span></div>   
            </div>

            <table class="table is-fullwidth is-narrow is-small" v-if="selectedSectionID !=2">
              <thead>
                <tr>
                  <th class="has-text-centered set-border" width="3%"  style="vertical-align: middle;">
                    # 
                  </th>
                  <th class="has-text-left set-border" width="30%"  style="vertical-align: middle;">
                    ສິນຄ້າ
                  </th>
                  <!-- <th class="has-text-centered set-border" width="5%"  style="vertical-align: middle;">
                    ຕ້ອງການ
                  </th> -->
                  <th class="has-text-centered set-border" width="5%"  style="vertical-align: middle;">
                    ຈຳນວນ
                  </th>
                  <th class="has-text-centered set-border" width="5%"  style="vertical-align: middle;">
                    ຫົວໜ່ວຍ
                  </th>
                  
                  <th class="has-text-centered set-border" width="10%"  style="vertical-align: middle;">
                    ລາຄາ
                  </th>
                  <th class="has-text-centered set-border" width="10%"  style="vertical-align: middle;">  
                    ຈຳນວນເງິນ
                  </th>
                  
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in productStockOutHistoryByProduct_print"
                  :key="data.ID"
                >
                  <td class="has-text-centered set-border" >{{ index + 1 }}      
                  </td>
                  
                  <td class="has-text-left set-border">
                    {{ data.OKPRODUCTNAME }} 
                  </td>  
                  <!-- <td class="has-text-right set-border" >
                      {{ data.OKQUANTITY }}
                  </td>  -->
                  <td class="has-text-right set-border" >
                      {{ data.OKQUANTITY }}
                  </td>     
                  <td class="has-text-right set-border" >
                      {{ data.OKUNIT }}
                  </td>  
                  
                 
                  <td class="has-text-right set-border" > 
                     {{ data.OKSELLUNITPRICE | formatNumberLocal }}
                     
                  </td> 
                  <td class="has-text-right set-border">
                    {{ Math.ceil(data.OKSELLUNITPRICE * data.OKQUANTITY) | formatNumberLocal }}
                  </td>     

                     
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="5" class="has-text-right set-border">
                   ລວມເງິນທັງໝົດ: 
                  </th>
                  <th class="has-text-right set-border" style=" font-weight: bold;">
                    
                      {{  
                        _.sumBy(productStockOutHistoryByProduct_print, (i) => i["OKSELLUNITPRICE"] * i["OKQUANTITY"] * 1)   
                          | formatNumberLocal  
                      }}
                  
                    
                  </th>
                  
                </tr>
              </tfoot>
              
            </table>

            <table class="table is-fullwidth is-narrow is-small" v-if="selectedSectionID ==2">
              <thead>
                <tr>
                  <th class="has-text-centered set-border" width="3%"  style="vertical-align: middle;">
                    # 
                  </th>
                  <th class="has-text-left set-border" width="30%"  style="vertical-align: middle;">
                    ສິນຄ້າ
                  </th>
                  <th class="has-text-centered set-border" width="5%"  style="vertical-align: middle;">
                    ຈຳນວນ
                  </th>
                  <th class="has-text-centered set-border" width="5%"  style="vertical-align: middle;">
                    ຫົວໜ່ວຍ
                  </th>
                  
                  <th class="has-text-centered set-border" width="10%"  style="vertical-align: middle;">
                    ລາຄາ
                  </th>
                  <th class="has-text-centered set-border" width="10%"  style="vertical-align: middle;">  
                    ຈຳນວນເງິນ
                  </th>
                  
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in productStockOutHistoryByProduct" :key="data.ID"
                  
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}      
                  </td>
                 
                  
                  <td class="has-text-left set-border">
                    {{ data.PRODUCTNAME }} 
                  </td>  
                  <td class="has-text-right set-border" >
                      <span style="color: red;">{{ data.QUANTITY}} </span>
                  </td>  
                  
                  <td class="has-text-right set-border" >
                       {{ data.UNIT }}
                  </td>  
                  
                  <td class="has-text-right set-border" >  
                    
                      {{ data.UNITPRICE | formatNumberLocal }}
                    
                  </td> 
                  <td class="has-text-right set-border" >  
                  
                      {{ data.UNITPRICE*data.QUANTITY| formatNumberLocal }}
                      
                  </td>
                  
                   

                  
                              
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="5" class="has-text-right set-border">
                   ລວມເງິນທັງໝົດ: 
                  </th>
                  <th class="has-text-right set-border" style=" font-weight: bold;">
                    
                      {{  
                        _.sumBy(productStockOutHistoryByProduct_print, (i) => i["UNITPRICE"] * i["QUANTITY"] * 1)   
                          | formatNumberLocal  
                      }}
                  
                    
                  </th>
                  
                </tr>
              </tfoot>
              
            </table>
            <div class="columns">
              <div class="column" style="margin-left: 20px;">
                <span style="font-size: 20px; font-weight: bold;  text-decoration: underline;">ຜູ້ຈ່າຍເງິນ</span>
              </div>
              <div class="column" style=" text-align: right; margin-right: 20px;">  
                <span style="font-size: 20px; font-weight: bold;  text-decoration: underline;">ຜູ້ຮັບເງິນ</span>
              </div>

            </div>
            
          </div>
        </div>
      </div>

      <div class="contain" v-else-if="printType==2">
        <div class="columns" style="" >    
          <div class="column" style="">
            <div style="">
              <div class="columns">      
                <div class="column">   
                  <div style="text-align: center;">
                    <div style="font-size: 20px; font-weight: bold;">ລາຍການສິນຄ້າເສຍຫາຍ  ປະຈຳວັນທີ: {{ dateFormatter(stockBrokenStartDate) }}</div>   
                    
                  </div>

                  <table class="table is-fullwidth is-narrow is-small" >   
                    <thead>
                      <tr style="height: 70px; "     >          
                        <th class="has-text-centered set-border" width="3%" style="vertical-align: middle; ">
                          #
                        </th>
                        <th class="has-text-centered set-border" width="15%" style="vertical-align: middle; ">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-centered set-border" width="5%" style="vertical-align: middle; ">
                          ຈຳນວນ <br>ເສຍຫາຍ 
                        </th>
                        <th class="has-text-centered set-border" width="40%" style="vertical-align: middle; ">   
                          ສາເຫດ
                        </th>
                        <th class="has-text-centered set-border" width="40%" style="vertical-align: middle; ">
                          ວິທີແກ້ໄຂ
                        </th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr style="height: 100px; !important"   
                        v-for="(data, index) in productStockBrokenHistory"
                        :key="data.ID"   
                      >
                        <td class="has-text-centered set-border" >{{ index + 1 }}
                        </td>

                        <td class="has-text-left set-border" >
                          <span style="font-weight: bold;">{{data.LOTID}}</span> {{  data.PRODUCTNAME }} <br> {{data.LOTTXDATE}} <br> ຍັງເຫຼືອ: <span style="font-weight: bold;">{{data.LOTREMAIN}}</span>
                        </td>            
                                
                        <td class="has-text-right set-border">
                          <span style="font-weight: bold;">{{ data.LOT_QUANTITY | formatNumberLocal }}</span> <br> {{ data.UNIT }}  
                        </td>  
                        <td class="has-text-right set-border">
                           
                        </td>
                        
                        <td class="has-text-right set-border" >  
                          
                        </td> 
                                    
                      </tr>
                    </tbody>
                    
                    
                  </table>
                </div>   
                
              </div>    
            </div>  
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
import _ from 'lodash';


export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect},

  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 1,

      activeTabSub: 2,

      activeTabSub2: 0,

      activeTabSub3: 0,   

      selectedVender: null,
      stockVenderList: [],

      stockDate: null,
      stockStartDate: null,
      stockEndDate: null,

      stockOutDate: null,

      quantityperpack: 0,
      
      selectedStockProduct: null,
      stockProductSub: [],

      selectedStockProductAmount: 0,
      selectedStockProductTotal: 0,

      stockProductList: [],
      selectedProduct: null,

      selectedPurchaser: null,
      purchaserList: [],

      stockinHistory: [],
      stockoutHistory: [],

      productInStock: [],
      selectedProductinStock: null ,

      selectedProductOutData: [],
      

      selectedStockProductSell: 0,
      selectedStockProductOfficeSell: 0,
      selectedStockProductBroken: 0,
      isActiveStockOutForm: 0,
      
      productInStockUsage: [],
      productInStockOutWait: [],
      productStockUsageMaxID: null,
      selectedRemainProduct: null,
      stockRemainProductList: [],

      stockStatusList: [
        { ID: 1, NAME: "ຍັງຢູ່ໃນສາງ" },
        { ID: 0, NAME: "ອອກສາງແລ້ວ" },
      ],
      selectedRemainProductStatus: { ID: 1, NAME: "ຍັງຢູ່ໃນສາງ" },

      productSummary: [],

      productStockOutHistory: [],
      productStockOutTxdate: [],

      stockBrokenStartDate: null,
      stockBrokenEndDate: null,

      productStockOutHistoryByProduct_print: [],
      productStockOutHistoryByProduct: [],
      productStockOutTxdateByProduct: [],
      accountStatus: 0,

      stockVenderProductList: [],
      selectedStockVender: null,
      selectedStockProductVender: null,

      selectedFProduct: null,
      fProductList: [],

      stockProductRemainDate: null,
      stockProductRemainList: [],
      stockProductRemainSavedList: [],
      isGetStockProductRemain: 0,

      isloadwait: 0,

      allStockProductList: [],
      okProductList: [],
      okProductName: null,
      okStockProductList: [],
      stockProductName: null,
      selectedStockProductIDForOk: null,
      selectedStockProductNameForOk: null,
      selectedStockProductUnitForOk: null,

      stockurl:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-office/#/stock/stockmanagement"
          : "http://localhost:8080/#/stock/stockmanagement",

      isUpdateMappingMultiply: false,
      selectedMultiply: 1,
      selectedMappingMultiplyProductname: null,
      selectedOKProductID: null,

      selectedStockProductQuantityForPOS: 0,
      selectedStockProductTotalForPOS: 0,

      selectedSection: null,
      selectedSectionID: null,
      stockSectionList: [
        { ID: 0, NAME: "ທັງໝົດ" },
        { ID: 1, NAME: "ອອກຕະຫຼາດ" },
        { ID: 2, NAME: "Stock POS" },
      ],

      groupList: [],
      selectedGroup: null,
      stockbuyandsell: [],
      stockbyandsellstartdate: null,
      stockbyandsellenddate: null,

      groupList2: [],
      selectedGroup2: null,
      stockbuyandsell2: [],
      stockbyandsellstartdate2: null,
      stockbyandsellenddate2: null,

      selectedProduct2: null,

      stockbuyandselldetail: [],
      stockbuyandsellProductID: null,
      stockbuyandsellProductName: null,

      url: "uploadreceiptimage", // function name in api site
      photoname: null,
      photopath:
        process.env.NODE_ENV === "production"   
        ? "https://agrilao.com/manager-main-pre/api/uploads/"   
        : "http://localhost/agrilao-manager-api/api/uploads/",    
      photopreview: null,

      productStockBrokenHistory_original: [],
      productStockBrokenHistory: [],
      productStockBrokenList: [],
      selectedProductStockBroken: null,
      brokentype: 1,
      isDisableProductButton: false,

      productStockCompareList: [],
      productStockCompareStartdate: null,
      productStockCompareEtartdate: null,

      stockBuyStartdate: null,
      stockBuyEnddate: null,
      stockBuyDateList: [],
      stockBuyDateDetail:[],
      activeTabSub4: 0,  

      selectedStockBuyDate_Date: null, 

      comparestartdate: null,
      compareenddate: null,
      compareMarketandStockList: [],

      okstockeastimatedate: null,
      okstockeastimateList: [],

      alloktotalsell: 0,


      stockSellStartdate: null,
      stockSellEnddate: null,
      stockSellReport: [],

      printType: 0,

    

    };

  },
  methods: {  

    reCalStockOut(lotid){
      if(this.productInStockUsage[0].VALUEREMAIN ==0){
        var loadingComponent = this.$loading.open({});         
        var params = {
          lotid: lotid,
          username: this.username,      
        };   
        
        RestAPI.reCalStockOut(params) 
        .then(() => {
          loadingComponent.close();
          this.getProductinStockUsage();

        })
        .catch((error) => {
          loadingComponent.close();
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
      }else{
        this.$swal("ຂໍ້ມູນຖືກຕ້ອງແລ້ວ !!!" , "-", "error");
      }
        

    },

    getStockSellReport(){
      var loadingComponent = this.$loading.open({});         
      var params = {
        startdate: this.dateFormatterYYYYMMDD(this.stockSellStartdate),
        enddate: this.dateFormatterYYYYMMDD(this.stockSellEnddate),
        username: this.username,      
      };   
      
      RestAPI.getStockSellReport(params) 
      .then((res) => {
        loadingComponent.close();
          this.stockSellReport = res.data;

      })
      .catch((error) => {
        loadingComponent.close();
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });
    },
    getOkStockEstimate(){
      var loadingComponent = this.$loading.open({});         
      var params = {
        txdate: this.dateFormatterYYYYMMDD(this.okstockeastimatedate),
        username: this.username,      
      };   
      
      RestAPI.getCheckStockByOKPurchase(params) 
      .then((res) => {
        loadingComponent.close();
          this.okstockeastimateList = res.data.estimate;
          this.alloktotalsell = res.data.allok.MARKET_STOCK_TOTAL;    

      })
      .catch((error) => {
        loadingComponent.close();
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });
    },

    getCompareMarketandStock(){
      var params = {
        startdate: this.dateFormatterYYYYMMDD(this.comparestartdate),
        enddate: this.dateFormatterYYYYMMDD(this.compareenddate),
        username: this.username,      
      };   
      
      RestAPI.getCompareMarketandStock(params) 
      .then((res) => {
          this.compareMarketandStockList = res.data;

      })
      .catch((error) => {
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });
    },

    getStockBuyDateDetail(txdate){
      this.activeTabSub4 = 1
      this.selectedStockBuyDate_Date = txdate;
      var params = {
          txdate: this.dateFormatterYYYYMMDD(txdate),
            username: this.username,      
          };   
          
         RestAPI.getStockBuyDateDetail(params) 
          .then((res) => {
             this.stockBuyDateDetail = res.data;

          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });

    },

    getStockBuyDateList(){
      var params = {
            startdate: this.dateFormatterYYYYMMDD(this.stockBuyStartdate),
            enddate: this.dateFormatterYYYYMMDD(this.stockBuyEnddate),   
            username: this.username,      
          };   
          
         RestAPI.getStockBuyDateList(params) 
          .then((res) => {
             this.stockBuyDateList = res.data;

          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },
    getProductStockCompare(){
      var params = {
            startdate: this.dateFormatterYYYYMMDD(this.productStockCompareStartdate),
            enddate: this.dateFormatterYYYYMMDD(this.productStockCompareEnddate),   
            username: this.username,      
          };   
          
         RestAPI.getProductStockCompare(params) 
          .then((res) => {
             this.productStockCompareList = res.data;

          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });

    },
    onSelectProductStockBroken(product){
      if (product) {
        this.productStockBrokenHistory = this.productStockBrokenHistory_original.filter(
          (item) => item.PRODUCTID === product.PRODUCTID
        );
      } else {
        this.productStockBrokenHistory = [...this.productStockBrokenHistory_original];
      }
    },
    sortDateData(key, order = 'desc') {

        this.productStockBrokenHistory_original.sort((a, b) => {
          let valueA = a[key];
          let valueB = b[key];

          // If both are numeric, sort as numbers
          if (!isNaN(valueA) && !isNaN(valueB)) {
            valueA = parseFloat(valueA) || 0;
            valueB = parseFloat(valueB) || 0;

            return order === 'desc' 
              ? valueB - valueA 
              : valueA - valueB;
          }

          // If not numeric, sort as strings
          valueA = valueA ? String(valueA) : '';
          valueB = valueB ? String(valueB) : '';

          return order === 'desc' 
            ? valueB.localeCompare(valueA) 
            : valueA.localeCompare(valueB);
        });
    },
    getProductStockBrokenHistory(type){
      this.brokentype = type;
      var params = {
            startdate: this.dateFormatterYYYYMMDD(this.stockBrokenStartDate),
            enddate: this.dateFormatterYYYYMMDD(this.stockBrokenEndDate),   
            type: type,
            username: this.username,      
          };   

          this.selectedProductStockBroken = null;   
          
         RestAPI.getProductStockBrokenHistory(params) 
          .then((res) => {
             this.productStockBrokenHistory = res.data.list;
             this.productStockBrokenHistory_original = res.data.list;
             this.productStockBrokenList = res.data.productlist;

             
            //  console.log("productInStock: "+ JSON.stringify(this.productInStock));
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },
    printStockOInvoice(){
      this.printType = 1;
      setTimeout(() => {
        var loadingComponent = this.$loading.open({}); 
        window.print(); 
        loadingComponent.close();

      }, 2000);
    },

    printStockBroken(){
      this.printType = 2;

      setTimeout(() => {
        var loadingComponent = this.$loading.open({}); 
        window.print(); 
        loadingComponent.close();

      }, 2000);
    },
    getStockbyuandsellresultonlybystockinDetail(productid, productname){
      this.stockbuyandsellProductID = productid;
      this.stockbuyandsellProductName = productname;
      this.activeTabSub3 = 1;   
      var params = {
        startdate: this.dateFormatterYYYYMMDD(this.stockbyandsellstartdate2),
        enddate: this.dateFormatterYYYYMMDD(this.stockbyandsellenddate2),  
        productid: productid,    
        username: this.username,  
      };

      RestAPI.getStockbyuandsellresultonlybystockinDetail(params)    
        .then((res) => {
           
          this.stockbuyandselldetail = res.data;
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
      });
    },
    getStockbyuandsellresultonlybystockin(){
      var params = {
        startdate: this.dateFormatterYYYYMMDD(this.stockbyandsellstartdate2),
        enddate: this.dateFormatterYYYYMMDD(this.stockbyandsellenddate2),  
        groupid: this.selectedGroup2 ?  this.selectedGroup2.ID : 0,      
        productid: this.selectedProduct2 ? this.selectedProduct2.ID : 0,    
        username: this.username,  
      };

      // console.log("params: "+JSON.stringify(params))  

      RestAPI.getStockbyuandsellresultonlybystockin(params)    
        .then((res) => {
           
          this.stockbuyandsell2 = res.data;
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
      });
    },
    getStockbyuandsellresult(){
      var params = {
        startdate: this.dateFormatterYYYYMMDD(this.stockbyandsellstartdate),
        enddate: this.dateFormatterYYYYMMDD(this.stockbyandsellenddate),  
        groupid: this.selectedGroup ?  this.selectedGroup.ID : 0,      
        productid: this.selectedProduct ? this.selectedProduct.ID : 0,    
        username: this.username,  
      };

      // console.log("params: "+JSON.stringify(params))  

      RestAPI.getStockbyuandsellresult(params)    
        .then((res) => {
           
          this.stockbuyandsell = res.data;
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
      });
    }, 
    cancelStockSellUnitPrice(index, type){  
      
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          const loadingComponent = this.$loading.open({});  
          var params;
         
          params = {
            data: this.productStockOutHistoryByProduct[index],
            stockoutdate:  this.dateFormatterYYYYMMDD(this.productStockOutTxdateByProduct) ,       
            type: type,       
            username: this.username,  
          };  
           
          // console.log("params: "+JSON.stringify(params))
             
          RestAPI.cancelStockSellUnitPrice(params) 
            .then((res) => {  
              loadingComponent.close();

              if(res.data=="ok"){
                this.getProductStockOutHistoryByProduct();
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              }else{
                this.$swal("ບໍ່ສຳເລັດ ", "-", "error");
                return false;

              } 
              
              
             })
            .catch((error) => {
              loadingComponent.close();
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
          });
        }
      });
    },
    cancelStockSellUnitPriceAll(){  
      
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          const loadingComponent = this.$loading.open({});  
          var params;
           
          params = {   
            data: this.productStockOutHistoryByProduct,
            stockoutdate:  this.dateFormatterYYYYMMDD(this.productStockOutTxdateByProduct) ,     
            username: this.username,  
          };  
           
             
          RestAPI.cancelStockSellUnitPriceAll(params) 
            .then((res) => {  
              loadingComponent.close();

              if(res.data=="ok"){
                this.getProductStockOutHistoryByProduct();
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              }else{
                this.$swal("ບໍ່ສຳເລັດ ", "-", "error");
                return false;

              } 
              
              
             })
            .catch((error) => {
              loadingComponent.close();
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
          });
        }
      });
    },
    saveStockSellUnitPriceAll(){   
      
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          const loadingComponent = this.$loading.open({});  
          var params;
         
          params = {
            data: this.productStockOutHistoryByProduct,
            stockoutdate:  this.dateFormatterYYYYMMDD(this.productStockOutTxdateByProduct) ,
            username: this.username,  
          };
           
          // console.log("pararms: " + JSON.stringify(params))       
          RestAPI.saveStockSellUnitPriceAll(params) 
            .then((res) => {     
              loadingComponent.close();

              if(res.data=="duplicated"){  
                this.$swal("ມີຂໍ້ມູນຢູ່ແລ້ວ ", "-", "error");   
                return false;
              }else if(res.data=="incorrectprice"){  
                this.$swal("ລາຄາບໍ່ຖືກຕ້ອງ ", "-", "error");   
                return false;
              }
              else if(res.data=="ok"){
                this.getProductStockOutHistoryByProduct();
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              }else{
                this.$swal("ບໍ່ສຳເລັດ ", "-", "error");
                return false;

              } 
              
              
             })
            .catch((error) => {
              loadingComponent.close();
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
          });
        }
      });
    },
    saveStockSellUnitPrice(index, type){  
      if(this.productStockOutHistoryByProduct[index].OKSELLUNITPRICE < 0 || this.productStockOutHistoryByProduct[index].OKSELLUNITPRICE == null){
        this.$swal("ປ້ອນລາຄາບໍ່ຖືກຕ້ອງ ", "-", "error");
        return false;
      }
      
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          const loadingComponent = this.$loading.open({});  
          var params;
         
          params = {
            data: this.productStockOutHistoryByProduct[index],
            stockoutdate:  this.dateFormatterYYYYMMDD(this.productStockOutTxdateByProduct) ,
            type: type,
            username: this.username,  
          };
           
          // console.log("pararms: " + JSON.stringify(params))       
          RestAPI.saveStockSellUnitPrice(params) 
            .then((res) => {     
              loadingComponent.close();

              if(res.data=="duplicated"){  
                this.$swal("ມີຂໍ້ມູນຢູ່ແລ້ວ ", "-", "error");   
                return false;
              }else if(res.data=="incorrectprice"){  
                this.$swal("ລາຄາບໍ່ຖືກຕ້ອງ ", "-", "error");   
                return false;
              }
              else if(res.data=="ok"){
                this.getProductStockOutHistoryByProduct();
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              }else{
                this.$swal("ບໍ່ສຳເລັດ ", "-", "error");
                return false;

              } 
              
              
             })
            .catch((error) => {
              loadingComponent.close();
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
          });
        }
      });
    },
    updateMainMappingMultiply(data, ismain){
      this.$swal({
          title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",    
          confirmButtonColor: "#d33",   
          cancelButtonColor: "#3085d6",
        }).then((result) => {
        if (result.value) {

          var params = {
            stockproductid: this.selectedStockProductIDForOk,
            okproductid: data.OKPRODUCTID,
            ismain: ismain,
            username: this.username,
          };

          // console.log("params: "+JSON.stringify(params))
            
          RestAPI.updateMainMappingMultiply(params)    
              .then(() => {
                this.selectStockProduct(this.selectedStockProductIDForOk, this.selectedStockProductNameForOk);
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");  
                }
            });
        
        }
      });
    },
    doUpdateMappingMultiply(){
      this.isUpdateMappingMultiply= false;
      this.$swal({
          title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",    
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
        if (result.value) {

          var params = {
            stockproductid: this.selectedStockProductIDForOk,
            okproductid: this.selectedOKProductID,
            multiply: this.selectedMultiply,  
            username: this.username,
          };
          // console.log("params: "+JSON.stringify(params))
            
          RestAPI.doUpdateMappingMultiply(params)    
              .then(() => {
                this.selectStockProduct(this.selectedStockProductIDForOk, this.selectedStockProductNameForOk);
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");  
                }
            });
        
        }
      });
    },
    updateMappingMultiply(data){
      this.selectedOKProductID = data.PRODUCTID;
      this.selectedMappingMultiplyProductname = data.PRODUCTNAME;
      this.isUpdateMappingMultiply= true;
      this.selectedMultiply = data.MULTIPLY;  
    },

    cancelMapOkStockProduct(okproductid){
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

            var params = {
              stockproductid: this.selectedStockProductIDForOk,
              okproductid: okproductid,  
              username: this.username,
            };
              
            RestAPI.cancelMapOkStockProduct(params)    
               .then(() => {
                  this.selectStockProduct(this.selectedStockProductIDForOk, this.selectedStockProductNameForOk);
                  this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });

      
    },


    mapOkStockProduct(okproductid){
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

            var params = {
              stockproductid: this.selectedStockProductIDForOk,
              okproductid: okproductid,  
              username: this.username,
            };

              
             RestAPI.mapOkStockProduct(params)    
               .then(() => {
                  this.selectStockProduct(this.selectedStockProductIDForOk, this.selectedStockProductNameForOk);
                  this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });

      
    },

    searchOkProductKey(){
      if(this.selectedStockProductIDForOk == null){ 
        this.$swal("ເລືອກສິນຄ້າສາງກ່ອນ ", "-", "error");  
        return false;
      }
      var params = {
        productkey: this.okProductName,  
      };
      
      RestAPI.searchOkProductKey(params)    
        .then((res) => {
           
           this.okProductList = res.data.search;
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
      });
    },

    selectStockProduct(ID, NAME, UNIT){
      this.selectedStockProductIDForOk = ID;
      this.selectedStockProductNameForOk = NAME;
      this.selectedStockProductUnitForOk = UNIT;
      this.okProductName  = NAME;

      var params = {
        stockproductid: this.selectedStockProductIDForOk
      };

      RestAPI.selectStockProduct(params)    
        .then((res) => {
           
          this.okStockProductList = res.data.mapped;
          this.searchOkProductKey();

        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
      });
    },

    getAllStockProductList(){
      var params = {
        productnamekey: this.stockProductName ? this.stockProductName : 0,      
      };

      // console.log("params---: " + JSON.stringify(params));

      RestAPI.getAllStockProductList(params)    
        .then((res) => {
          this.allStockProductList = [];
          this.allStockProductList = res.data; 
          // console.log("res.data: " +JSON.stringify(res.data));

        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
      });


      // RestAPI.getAllStockProductList(productnamekey)
      // .then((res) => {
      //   this.allStockProductList = res.data;
      // })
      
      // .catch((error) => {
      //   console.log(error);
      //   this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      // });
    },

    approveStockOutWait(waitid, marketbatchid){
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                id: waitid,
                marketbatchid: marketbatchid,
                productid: this.selectedProductOutData.PRODUCTID,
                username: this.username,  
              };

              // console.log("params: " + JSON.stringify(params))
              
             RestAPI.approveStockOutWait(params)    
               .then((res) => {
                  if(res.data=="lessthan0"){
                    this.$swal("ສິນຄ້າບໍ່ພໍ", "-", "error");
                    return false;
                  }
                  this.getProductinStockUsage();
                  this.getProductinStock();
                  this.getStockHistory();
                  this.getProductInStockSummary();
                  this.getProductInStockSummaryForOrder();
                  this.getRemainProduct();
                  this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
    },

    cancelProductStockOutWait(data){
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                id: data.ID,
                amount: parseFloat(data.SELL) + parseFloat(data.OFFICESELL) + parseFloat(data.BROKEN),
                stockhistoryid: data.STOCKHISTORYID,  
                marketbatchid: data.MARKETBATCHID,  
                productid: data.PRODUCTID,  
                username: this.username,  
              };

              // console.log("params: " + JSON.stringify(params))
              
             RestAPI.cancelProductStockOutWait(params)    
               .then(() => {
                   this.getProductinStockUsage();
                  this.getProductinStock();
                  this.getStockHistory();
                  this.getProductInStockSummary();
                  this.getProductInStockSummaryForOrder();
                  this.getRemainProduct();
                  this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }  
        });
    }, 

    saveProductRemainToStock(){
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {
              
              var params = {
                data: this.stockProductRemainList,
                username: this.username,  
              };
              

             RestAPI.saveProductRemainToStock(params) 
               .then(() => {
                  this.isGetStockProductRemain = 1;
                  this.getStockProductRemainSaved();
                  
                 
                 this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
    },

    getStockProductRemain(){
      this.isGetStockProductRemain = 0;
      this.getProductInStockSummaryForOrder();
    },

    getStockProductRemainSaved(){
      this.isGetStockProductRemain = 1;
      RestAPI.getStockProductRemainSaved(this.dateFormatterYYYYMMDD(this.stockProductRemainDate))
      .then((res) => {
        this.stockProductRemainSavedList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },
    
    saveProductToStock(){
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {
              this.selectedStockVender = {"ID": this.selectedStockProductVender.ID,"NAME": this.selectedStockProductVender.NAME};   
              
              var params = {
                stockvenderid: this.selectedStockProductVender.ID,
                productid: this.selectedFProduct.ID,
                username: this.username,  
              };
              
              // console.log("params: "+JSON.stringify(params))
             RestAPI.saveProductToStock(params) 
               .then((res) => {
              // console.log("res: "+JSON.stringify(res))    
                  this.getStockVenderProduct();
                  if(res.data == 'duplicate'){
                    this.$swal("ສິນຄ້າຊ້ຳ, ລອງໃໝ່", "", "error");
                    return false;
                  }
                
                
                 this.selectedStockProductVender = null;
                 this.selectedFProduct = null;
                 this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
    },

    getStockVenderProduct(){
      // console.log("this.selectedVender.ID: " + this.selectedVender.ID)
      RestAPI.getStockVenderProductV2(this.selectedStockVender.ID)
      .then((res) => {
        this.stockVenderProductList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });

    },

    getFproductList(){
      // console.log("this.selectedVender.ID: " + this.selectedVender.ID)
      RestAPI.getFproductListForStock()
      .then((res) => {
        this.fProductList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });

    },

    getProductInStockSummaryForOrder() {
      RestAPI.getProductInStockSummaryForOrder()
      .then((res) => {
        this.productSummary = res.data;
        this.stockProductRemainList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    getProductInStockSummary() {
      RestAPI.getProductInStockSummary()
      .then((res) => {
        this.productSummary = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    onSelectedStockRemainProduct(type){
      this.isloadwait = type;
      this.getProductinStock();
      // console.log("onSelectedStockRemainProduct")

    },

    cancelProductStockUsage(data){
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                id: data.ID,
                productid: data.OKPRODUCTID,
                marketbatchid: data.MARKETBATCHID,
                username: this.username,  
              };
              
             RestAPI.cancelProductStockUsage(params) 
               .then(() => {
                   this.getProductinStockUsage();
                  this.getProductinStock();
                  this.getStockHistory();
                  this.getProductInStockSummary();
                  this.getProductInStockSummaryForOrder();
                  this.getRemainProduct();
                  this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
    },   

    cancelProductStockIn(id, marketbatchid, purchaserid){ 
      this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {   
          if (result.value) {

              var params = {
                id: id,
                marketbatchid: marketbatchid,   
                purchaserid: purchaserid,
                username: this.username,  
              };
              
             RestAPI.cancelProductStockIn(params) 
               .then((res) => {
                  if(res.data=="ok"){
                    this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                    this.getProductinStock();
                    this.getStockHistory();
                    this.getProductInStockSummary();
                    this.getProductInStockSummaryForOrder();
                    this.getRemainProduct();
                  }else if(res.data=="nomarketbatchid"){
                    this.$swal("ບໍ່ພົບໃນລາຍການສັ່ງຊື້ " , "-", "error");
                    return false;
                  }else if(res.data=="savedpayment"){
                    this.$swal("ບັນທຶກບັນຊີແລ້ວ ບໍ່ສາມາດຍົກເລິກໄດ້" , "-", "error");
                    this.getProductinStock();
                    this.getStockHistory();
                    this.getProductInStockSummary();
                    this.getProductInStockSummaryForOrder();
                    this.getRemainProduct();
                    return false;
                  }
                  
                 
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
    },

    getProductInStockDetail(data){  
      this.activeTabSub= 1;
      this.selectedProductOutData = data;
      this.isActiveStockOutForm = true;
      this.getProductinStockUsage();
    },

    saveStockOutForPOS(){    
      if(this.selectedStockProductQuantityForPOS == 0 || this.selectedStockProductTotalForPOS ==0){
         this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");
          return false;
        }
        
        this.$swal({
            title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                txdate: this.dateFormatterYYYYMMDD(this.stockOutDate),
                stockhistoryid: this.selectedProductOutData.ID,
                quantity: this.selectedStockProductQuantityForPOS,
                total: this.selectedStockProductTotalForPOS,
                productid: this.selectedProductOutData.PRODUCTID,
                productname: this.selectedProductOutData.PRODUCTNAME,
                producttypename: this.selectedProductOutData.PRODUCTTYPENAME,
                photoname: this.selectedProductOutData.PHOTONAME,
                unit: this.selectedProductOutData.UNIT,
                username: this.username,  
              };
              
              // console.log("params: "+JSON.stringify(params))  

             RestAPI.saveStockOutForPOS(params)  
               .then((res) => {
                  if(res.data == 'ok'){
                    this.getProductinStockUsage();
                    this.getProductinStock();
                    this.getStockHistory();
                    this.getProductInStockSummary();
                    this.getProductInStockSummaryForOrder();
                    this.getRemainProduct();
                    this.selectedStockProductQuantityForPOS = 0;
                    this.selectedStockProductTotalForPOS = 0;
                    this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                  }else if(res.data == 'no'){   
                    this.$swal("ດຳເນີນການບໍ່ສຳເລັດ", "", "error");  
                  }
                  else if(res.data == 'lessthan0'){  
                    this.$swal("ເຄື່ອງອອກ ຫຼາຍກວ່າ ເຄື່ອງທີ່ມີໃນສາງ!", "", "error");
                    return false;
                  }

                  
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });

     
    },

    saveStockOut(){ 
      if(this.selectedStockProductSell == 0 && this.selectedStockProductOfficeSell==0  && this.selectedStockProductBroken ==0){
         this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");
          return false;
        }
        
        this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",    
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                txdate: this.dateFormatterYYYYMMDD(this.stockOutDate),
                stockhistoryid: this.selectedProductOutData.ID,
                sell: this.selectedStockProductSell,
                officesell: this.selectedStockProductOfficeSell,
                broken: this.selectedStockProductBroken,
                productid: this.selectedProductOutData.PRODUCTID,
                username: this.username,  
              };
              
              // console.log("params: "+JSON.stringify(params))
             RestAPI.saveStockOut(params) 
               .then((res) => {
                  if(res.data == 'lessthan0'){
                    this.$swal("ເຄື່ອງອອກ ຫຼາຍກວ່າ ເຄື່ອງທີ່ມີໃນສາງ!", "", "error");
                    return false;
                  }

                  this.getProductinStockUsage();
                  this.getProductinStock();
                  this.getStockHistory();
                  this.getProductInStockSummary();
                  this.getProductInStockSummaryForOrder();
                  this.getRemainProduct();
                  this.selectedStockProductSell = 0;
                  this.selectedStockProductOfficeSell = 0;
                  this.selectedStockProductBroken = 0;
                 this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });

     
    },

    onSelectVender(){
      var venderid=  this.selectedVender.ID

      RestAPI.getStockProductByVenderV2(venderid)
        .then((res) => {
          this.stockProductSub = res.data; 


        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    saveStockIn(){ 
      if(this.selectedVender== null || this.selectedStockProduct == null || this.selectedStockProductAmount == 0 || this.selectedStockProductTotal== 0){     
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");

      }else{
        this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",  
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                txdate: this.dateFormatterYYYYMMDD(this.stockDate),
                productid: this.selectedStockProduct.ID,
                quantity: this.selectedStockProductAmount,
                total: this.selectedStockProductTotal,
                venderid: this.selectedVender.ID,
                username: this.username,  
              };

              // console.log("params: "+JSON.stringify(params))  
              
             RestAPI.saveStockIn(params) 
               .then(() => {
                //  this.allProfitStatus();
                  // this.selectedVender = [];
                  // this.stockProductSub = [];
                  this.selectedStockProduct = null;
                  this.selectedStockProductAmount= 0;
                  this.selectedStockProductTotal = 0;
                  

                  this.getStockHistory();
                  this.getProductinStock();
                  this.getStockProductList();
                  this.getProductInStockSummary();
                  this.getProductInStockSummaryForOrder();
                  this.getRemainProduct();
                  
                  this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
      }
      
     
    },

    getProductinStockUsage(){// 
      var params = {
            stockhistoryid: this.selectedProductOutData.ID,
            username: this.username,      
          };   
            
         RestAPI.getProductinStockUsage(params) 
          .then((res) => {
             this.productInStockUsage = res.data.list;
             this.productInStockOutWait = res.data.wait;
             this.productStockUsageMaxID = res.data.max.MAXID;

             
            //  console.log("productInStock: "+ JSON.stringify(this.productInStock));
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getProductStockOutHistory(){// 
      var params = {
            txdate: this.dateFormatterYYYYMMDD(this.productStockOutTxdate),
            username: this.username,      
          };   
          
         RestAPI.getProductStockOutHistory(params) 
          .then((res) => {
             this.productStockOutHistory = res.data.list;

             
            //  console.log("productInStock: "+ JSON.stringify(this.productInStock));
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getProductStockOutHistoryByProduct(){// 
      this.selectedSectionID = this.selectedSection ? this.selectedSection.ID : 0;   
      var params = {
            section: this.selectedSectionID ,
            txdate: this.dateFormatterYYYYMMDD(this.productStockOutTxdateByProduct),   
            username: this.username,      
          };     

          // console.log("params: "+ JSON.stringify(params));
        const loadingComponent = this.$loading.open({});  
         RestAPI.getProductStockOutHistoryByProduct(params) 
          .then((res) => { 
            loadingComponent.close();
             this.productStockOutHistoryByProduct = res.data.list;
             this.productStockOutHistoryByProduct_print = res.data.print ? res.data.print : null;  
             this.accountStatus = res.data.account.CHECKSTATUS;

            //  console.log(" res.data.print: "+ JSON.stringify( res.data.print));


             
            //  console.log("productInStock: "+ JSON.stringify(this.productInStock));
          })
          .catch((error) => {
            loadingComponent.close();
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getRemainProduct(){// 
         RestAPI.getRemainProduct() 
          .then((res) => {
             this.stockRemainProductList = res.data;
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getProductinStock(){// 
      this.productInStock = [];
      var params = {
            productid: this.selectedRemainProduct ? this.selectedRemainProduct.ID : 0,
            stockstatus: this.selectedRemainProductStatus.ID,
            isloadwait: this.isloadwait,
            username: this.username,      
          };   
          
         RestAPI.getProductinStock(params) 
          .then((res) => {
            // console.log("productInStock res: "+ JSON.stringify(res.data));
             this.productInStock = res.data;
            //  console.log("productInStock: "+ JSON.stringify(this.productInStock));
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getStockHistory(type=1){// type= 1 is in, 2 is out
      var params = {
            type: type,
            startdate: this.dateFormatterYYYYMMDD(this.stockStartDate),  
            enddate: this.dateFormatterYYYYMMDD(this.stockEndDate),  
            productid: this.selectedProduct ? this.selectedProduct.ID : 0,
            purchaserid: this.selectedPurchaser ? this.selectedPurchaser.ID : 0,   
            username: this.username,      
          };   

          console.log("params: "+ JSON.stringify(params));
          
         RestAPI.getStockHistory(params) 
          .then((res) => {
            // console.log("getStockHistory: " + JSON.stringify(res.data));
            if(type==1){
              this.stockinHistory =  res.data;
            }else{
              this.stockoutHistory =  res.data;
            }
            
            this.stockRemain = res.data.stockRemain;            
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getStockProductList() {
      RestAPI.getStockProductList()
      .then((res) => {
        this.stockProductList = res.data.product;
        this.purchaserList = res.data.purchaser;
        // console.log("purchaserList: " + JSON.stringify(res.data.purchaser));
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    


    getStockVenderList() {
      RestAPI.getStockVenderList()
      .then((res) => {
        this.stockVenderList = res.data.stockVenderList;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    getStockProductGroup() {
      RestAPI.getClinicStockProductGroup()
        .then((res) => {
          this.groupList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getImgUrl(photoname) { 
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      return photopreview;
    },
   

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;

    this.currentDate = new Date();

    this.startDate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth(),
      1
    );
    this.endDate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth() + 1,
      0
    );

    this.stockDate =  new Date(this.currentDate);
    this.stockStartDate = this.startDate;
    this.stockEndDate = this.endDate;

    this.stockProductRemainDate = new Date(this.currentDate);

    this.stockOutDate =  new Date(this.currentDate);

    this.productStockOutTxdate =  new Date(this.currentDate);
    this.productStockOutTxdateByProduct =  new Date(this.currentDate);
    // this.productStockOutTxdateByProduct = new Date("2025-07-22");  

    this.stockbyandsellstartdate  = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth(),
      1 
    );
    this.stockbyandsellenddate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth() + 1,
      0
    );

    this.stockbyandsellstartdate2  = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth(),
      1
    );
    this.stockbyandsellenddate2 = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth() + 1,
      0
    );


    this.stockBuyStartdate = this.startDate;
    this.stockBuyEnddate = this.endDate;



    this.stockBrokenStartDate= new Date(this.currentDate);  
    this.stockBrokenEndDate= new Date(this.currentDate);  

    this.productStockCompareStartdate = new Date(this.currentDate);  
    this.productStockCompareEnddate = new Date(this.currentDate);  

    var date = new Date(this.currentDate);
    date.setDate(date.getDate() - 7);
    this.okstockeastimatedate = date;

    this.comparestartdate = this.startDate;
    this.compareenddate = this.endDate;


    this.stockSellStartdate = this.startDate;
    this.stockSellEnddate  = this.endDate;
    
    this.getStockVenderList();
    this.getStockProductList();
    this.getStockHistory();
    this.getProductinStock();
    this.getRemainProduct();
    this.getProductInStockSummary();
    this.getProductInStockSummaryForOrder();
    this.getProductStockOutHistory();
    this.getProductStockOutHistoryByProduct();
    this.getFproductList();
    this.getStockProductRemainSaved();
    this.getAllStockProductList();
    this.getStockProductGroup();
    this.getStockbyuandsellresult();
    this.getStockbyuandsellresultonlybystockin();
    

  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    notEnoughTotalSellSum() {
      return _.sumBy(this.okstockeastimateList, i => Number(i['NOTENOUGH_TOTALSELL']));
    },

   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .tab-content{
    padding: 0 !important;
  }

.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-35 {
  flex: 0 0 20%;
}
.column-65 {
  flex: 0 0 80%;
}


.column-40 {
  flex: 0 0 40%;
}
.column-60 {
  flex: 0 0 60%;
}

.column-30 {
  flex: 0 0 35%;
}
.column-70 {
  flex: 0 0 70%;
}

.column-20 {
  flex: 0 0 20%;
}
.column-80 {
  flex: 0 0 80%;
}


.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.loading-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Make sure the modal is on top of other content */
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 80%; /* Adjust width as needed */
  max-width: 300px;
}

.modal-content2 {
  padding: 0px 20px 20px 80px;
  border-radius: 10px;
  width: 100%; /* Full width of the modal */
  margin-top: 20px; /* Space between the QR code and content */
  text-align: left; /* Align content to the left */
}

.modal-content2 div {
  margin-bottom: 0px; /* Space between the lines */
  margin-top: -20px;
  font-size: 18px;
}

.modal-title {
  font-size: 26px;
  font-weight: bold; 
  margin-bottom: 10px; 
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
